/* kdChartJS 1.0.0 @ 2022-03-04T02:59:47.204Z */
import * as d3 from './d3';

var ViewOffset = 1000;
var LimitLevel = 3;
var ElbowRatio = 0.5;
var PathUpStep = 6;
var SVGFontFamily = "Microsoft YaHei, PingFangSC-Regular, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB, WenQuanYi Micro Hei, sans-serif";
var chart_width_f500 = {
    "0": 8, "1": 8, "2": 8, "3": 8, "4": 8, "5": 8, "6": 8, "7": 8, "8": 8, "9": 8, "a": 8, "b": 9, "c": 7, "d": 9, "e": 8, "f": 6, "j": 2, "h": 9, "i": 4, "k": 8, "l": 4, "m": 13, "n": 9, "o": 9, "p": 9, "q": 9, "r": 6, "s": 7, "t": 6, "u": 9, "v": 7, "w": 11, "x": 7, "y": 7, "z": 6, "A": 10, "B": 9, "C": 9, "D": 11, "E": 8, "F": 8, "G": 10, "H": 11, "I": 4, "J": 5, "K": 10, "L": 8, "M": 14, "N": 11, "O": 11, "P": 9, "Q": 12, "R": 10, "S": 8, "T": 9, "U": 10, "V": 9, "W": 14, "X": 9, "Y": 8, "Z": 8, "~": 10, "!": 4, "@": 14, "#": 8, "$": 8, "%": 13, "^": 10, "&amp;": 13, "*": 7, "(": 5, ")": 4, "_": 6, "-": 6, "+": 10, "=": 10, "[": 5, "]": 5, "{": 5, "}": 5, "|": 4, ";": 2, "'": 4, ":": 3, "\"": 6, "&lt;": 10, "&gt;": 10, "?": 7, ",": 2, ".": 3, "/": 6, "`": 4, "\\": 6
};
var chart_width_f600 = {
    "0": 9, "1": 9, "2": 9, "3": 9, "4": 8, "5": 9, "6": 9, "7": 9, "8": 9, "9": 9, "a": 8, "b": 10, "c": 7, "d": 9, "e": 9, "f": 7, "j": 2, "h": 9, "i": 4, "k": 9, "l": 4, "m": 14, "n": 9, "o": 9, "p": 10, "q": 9, "r": 7, "s": 7, "t": 6, "u": 9, "v": 8, "w": 12, "x": 8, "y": 8, "z": 7, "A": 10, "B": 10, "C": 10, "D": 11, "E": 8, "F": 8, "G": 11, "H": 12, "I": 5, "J": 6, "K": 11, "L": 8, "M": 14, "N": 12, "O": 12, "P": 10, "Q": 13, "R": 11, "S": 9, "T": 8, "U": 11, "V": 10, "W": 15, "X": 10, "Y": 9, "Z": 10, "~": 11, "!": 5, "@": 14, "#": 9, "$": 9, "%": 13, "^": 11, "&amp;": 13, "*": 7, "(": 7, ")": 4, "_": 6, "-": 6, "+": 11, "=": 11, "[": 6, "]": 5, "{": 6, "}": 5, "|": 5, ";": 3, "'": 4, ":": 4, "\"": 7, "&lt;": 11, "&gt;": 11, "?": 7, ",": 3, ".": 4, "/": 6, "`": 5, "\\": 7
};
var ICONFONT_CLASS = "iconfont";
var ICON_COLOR;
(function (ICON_COLOR) {
    ICON_COLOR["toogleMinus"] = "#1890FF";
    ICON_COLOR["tooglePlus"] = "#999";
    ICON_COLOR["drillup"] = "#1890FF";
    ICON_COLOR["drillDown"] = "#1890FF";
})(ICON_COLOR || (ICON_COLOR = {}));
var ICON_UNICODE;
(function (ICON_UNICODE) {
    ICON_UNICODE["toogleMinus"] = "-";
    ICON_UNICODE["tooglePlus"] = "+";
    ICON_UNICODE["drillup"] = "^";
    ICON_UNICODE["drillDown"] = "v";
})(ICON_UNICODE || (ICON_UNICODE = {}));
var SVG_THEME;
(function (SVG_THEME) {
    SVG_THEME["background"] = "#fff";
})(SVG_THEME || (SVG_THEME = {}));
var DEFAULT_CARDSIZE = {
    width: 120,
    height: 50,
    xSpace: 18,
    ySpace: 48
};

function eachObj(data, cb) {
    each([data]);
    function each(list) {
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            cb(item);
            if (item.children && item.children.length > 0) {
                each(item.children);
            }
        }
    }
}
function searchNodeByID(data, id, cb) {
    var rootList = [data];
    each(rootList);
    function each(list) {
        for (var i = 0; i < list.length; i++) {
            if (list[i].id === id) {
                cb(list[i]);
                break;
            }
            list[i].children && each(list[i].children);
        }
    }
}
function exchangeItemSort(list, i, j) {
    var movei = list[i];
    if (i > j) {
        list.splice(j, 0, movei);
        i += 1;
    }
    else {
        list.splice(j + 1, 0, movei);
    }
    list.splice(i, 1);
}

var TreeDataObj = /** @class */ (function () {
    function TreeDataObj(kdChartObj, treeData) {
        if (!treeData)
            return;
        this._data = treeData;
        this.kdChartObj = kdChartObj;
        this.formateData(this._data, null);
        this.limitDataLevel(this._data);
    }
    Object.defineProperty(TreeDataObj.prototype, "data", {
        get: function () {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    TreeDataObj.prototype.resetData = function (newTreeData) {
        this._data = newTreeData;
        this.formateData(this._data, null);
        this.limitDataLevel(this._data);
    };
    TreeDataObj.prototype.formateData = function (treeData, parent) {
        function eachObj(currData, pData) {
            currData.hasParent = !!pData || !!currData.hasParent;
            currData.parent = pData;
            currData.hasChild = (!!currData.children && currData.children.length > 0) || !!currData.hasChild;
            currData._children = currData.children;
            if (!!currData.children && currData.children.length > 0) {
                currData.children.map(function (childCurrData) {
                    eachObj(childCurrData, currData);
                });
            }
        }
        eachObj(treeData, parent);
    };
    TreeDataObj.prototype.foldData = function (node) {
        searchNodeByID(this._data, node.id, function (item) {
            item._children = item.children;
            item.children = null;
        });
    };
    TreeDataObj.prototype.openData = function (node) {
        searchNodeByID(this._data, node.id, function (item) {
            item.children = item._children;
        });
    };
    TreeDataObj.prototype.changeRoot = function (rootID) {
        var _this = this;
        searchNodeByID(this._data, rootID, function (item) {
            _this._data = item;
        });
    };
    TreeDataObj.prototype.supplyChildData = function (id) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.supplyChild(id, function (child) {
                searchNodeByID(_this._data, id, function (item) {
                    item.children = child;
                    _this.formateData(item, item.parent);
                    resolve(null);
                });
            });
        });
    };
    TreeDataObj.prototype.supplyParentData = function (id, isSyncData) {
        var _this = this;
        return new Promise(function (resolve) {
            if (isSyncData) {
                _this._data = _this._data.parent;
                _this.limitDataLevel(_this._data);
                resolve(null);
            }
            else {
                _this.supplyParent(id, function (parent) {
                    _this.composeParentData(id, parent);
                    _this.formateData(parent, null);
                    resolve(null);
                });
            }
        });
    };
    TreeDataObj.prototype.composeParentData = function (id, parent) {
        for (var i = 0; i < parent.children.length; i++) {
            var item = parent.children[i];
            if (item.id === id) {
                item.children = this._data.children;
                break;
            }
        }
        this._data = parent;
        this.limitDataLevel(this._data);
    };
    TreeDataObj.prototype.limitDataLevel = function (treeData) {
        var limitLevel = this.kdChartObj.cardConfig.limitLevel;
        function eachTreeData(citem, level) {
            if (citem.children && citem.children.length > 0) {
                citem.children.map(function (child) {
                    eachTreeData(child, level + 1);
                });
            }
            if (level === limitLevel) {
                citem._children = citem.children;
                citem.children = null;
            }
        }
        eachTreeData(treeData, 1);
    };
    TreeDataObj.prototype.supplyChild = function (id, cb) {
        return null;
    };
    TreeDataObj.prototype.supplyParent = function (id, cb) {
        return null;
    };
    TreeDataObj.prototype.exchangeItem = function (pid, i, j) {
        searchNodeByID(this._data, pid, function (parent) {
            exchangeItemSort(parent.children, i, j);
        });
    };
    TreeDataObj.prototype.changeNodeLoad = function (id) {
        searchNodeByID(this._data, id, function (item) {
            item.isLeaf = !item.isLeaf;
        });
    };
    TreeDataObj.prototype.addOneCrad = function (pid) {
        var _this = this;
        searchNodeByID(this._data, pid, function (node) {
            var _a;
            node.children = (_a = node.children) !== null && _a !== void 0 ? _a : [];
            var newID = pid + "tomychild" + node.children.length;
            node.children.push({
                id: newID,
                info: {
                    name: node.info.name + "的下级" + newID,
                },
                isLeaf: false
            });
            _this.formateData(node, node.parent);
        });
        this.limitDataLevel(this._data);
    };
    TreeDataObj.prototype.delOneCrad = function (id) {
        var _this = this;
        searchNodeByID(this._data, id, function (node) {
            console.log(node);
            var delIndex = -1;
            if (node.hasParent) {
                for (var i = 0; i < node.parent.children.length; i++) {
                    if (node.parent.children[i].id === id) {
                        delIndex = i;
                        break;
                    }
                }
                node.parent.children.splice(delIndex, 1);
                _this.formateData(node.parent, node.parent.parent);
            }
        });
        this.limitDataLevel(this._data);
    };
    TreeDataObj.prototype.delCards = function (delIDs) {
        each(this._data);
        console.log(this._data);
        function each(obj) {
            if (obj.children && obj.children.length > 0) {
                obj.children = obj.children.filter(function (item) {
                    return delIDs.indexOf(item.id) === -1;
                });
                obj.children.map(function (item) {
                    each(item);
                });
            }
        }
        this.formateData(this._data, null);
        this.limitDataLevel(this._data);
    };
    return TreeDataObj;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var ChartDataObj = /** @class */ (function () {
    function ChartDataObj(kdChartObj, computedCoordinate, formatDataFunc) {
        if (!kdChartObj.treeData.data)
            return;
        this.userComputedLoc = computedCoordinate;
        this.formatDataFunc = formatDataFunc;
        this.kdChartObj = kdChartObj;
        this.initParams();
        this.formatData(this._data);
    }
    Object.defineProperty(ChartDataObj.prototype, "data", {
        get: function () {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    ChartDataObj.prototype.resetData = function () {
        this.initParams();
        this.formatData(this._data);
    };
    ChartDataObj.prototype.initParams = function () {
        this.maxDepth = 0;
        this._data = this.initData();
    };
    ChartDataObj.prototype.initData = function () {
        var locMap = this.getLocationalMap();
        var getNodes = this.descendants;
        var getLinks = this.links;
        function foreach(list, parent, level) {
            if (parent === void 0) { parent = null; }
            if (level === void 0) { level = 0; }
            var children = [];
            for (var i = 0; i < list.length; i++) {
                var treeItem = __assign(__assign({ id: list[i].id, data: list[i], level: level, parent: parent }, locMap[list[i].id]), { getNodes: getNodes, getLinks: getLinks });
                treeItem.x0 = treeItem.x;
                treeItem.y0 = treeItem.y;
                if (list[i].children && list[i].children.length > 0) {
                    treeItem.children = foreach(list[i].children, treeItem, level + 1);
                    treeItem._children = treeItem.children;
                }
                children.push(treeItem);
            }
            return children;
        }
        return foreach([this.kdChartObj.treeData.data], null, 0)[0];
    };
    //卡片节点对象的属性
    ChartDataObj.prototype.formatData = function (data) {
        var _this = this;
        data.getNodes().forEach(function (node) {
            _this.formatDataFunc(node);
            _this.formateCard(node);
        });
    };
    ChartDataObj.prototype.formateCard = function (node) {
        var isLeaf = node.data.isLeaf || false;
        var cardModel = this.kdChartObj.kdGetCardModel(node, this._data);
        //卡片模板变更，触发重绘
        node.cardChange = (cardModel !== node.cardModel) || (isLeaf !== node.isLeaf);
        node.isLeaf = isLeaf;
        node.cardModel = cardModel;
        node.cardSize = this.kdChartObj.keGetCardSize(node, this._data);
    };
    //重新计算坐标
    //一般接：manViewObj.resetPaint。重绘结构图
    ChartDataObj.prototype.resetChartData = function () {
        var _this = this;
        var locMap = this.getLocationalMap();
        this._data.getNodes().forEach(function (node) {
            var newLoc = locMap[node.id];
            node.x = newLoc.x;
            node.y = newLoc.y;
            node.depth = newLoc.depth;
            node.height = newLoc.offsetHeight;
            _this.formateCard(node);
            _this.maxDepth = Math.max(node.depth, _this.maxDepth);
        });
    };
    ChartDataObj.prototype.changeRoot = function (node) {
        //下钻
        var newRootNode = node;
        while (newRootNode.parent.id !== this._data.id) {
            newRootNode = newRootNode.parent;
        }
        this._data = newRootNode;
    };
    ChartDataObj.prototype.supplyChildData = function (currNode) {
        var _this = this;
        return new Promise(function (resolve) {
            var chartDataObj = {};
            _this.initData().getNodes().forEach(function (node) {
                chartDataObj[node.id] = node;
            });
            searchNodeByID(_this._data, currNode.id, function (node) {
                var newNode = chartDataObj[node.id];
                //挂载新增节点
                node.children = newNode.children;
                node._children = node.children;
                //处理新增节点
                _this.formatData(currNode);
                //处理新增子项
                node.children.length > 0 && node.children.map(function (cnode) {
                    cnode.parent = node;
                    cnode._children = cnode.children;
                    cnode.children = null;
                });
            });
            resolve(null);
        });
    };
    ChartDataObj.prototype.supplyParentData = function (id) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.initParams();
            _this.formatData(_this._data);
            resolve(null);
        });
    };
    ChartDataObj.prototype.syncLoc = function () {
        this._data.getNodes().forEach(function (node) {
            node.x0 = node.x;
            node.y0 = node.y;
        });
    };
    ChartDataObj.prototype.getLocationalMap = function () {
        var locMap = null;
        if (this.userComputedLoc) {
            // console.log("用户计算坐标");
            locMap = this.userComputedLoc(this.kdChartObj.treeData.data, this.kdChartObj.cardConfig.baseCardSize, this.kdChartObj.svgWrapperSize, this.kdChartObj.viewConfig.direction);
        }
        else {
            // console.log("默认计算坐标");
            locMap = this.computedCoordinate();
        }
        return locMap;
    };
    ChartDataObj.prototype.foldData = function (node) {
        node.children = null;
    };
    ChartDataObj.prototype.openData = function (node) {
        node.children = node._children;
    };
    ChartDataObj.prototype.computedCoordinate = function () {
        var res = {};
        var treeData = this.kdChartObj.treeData.data;
        var tree = d3.tree().nodeSize([
            this.kdChartObj.cardConfig.baseCardSize.width + this.kdChartObj.cardConfig.baseCardSize.xSpace,
            this.kdChartObj.cardConfig.baseCardSize.height + this.kdChartObj.cardConfig.baseCardSize.ySpace,
        ]);
        var root = d3.hierarchy(treeData);
        tree(root);
        root.descendants().forEach(function (node) {
            res[node.data.id] = {
                x: node['x'],
                y: node['y'],
                depth: node.depth
            };
        });
        return res;
    };
    ChartDataObj.prototype.descendants = function () {
        var res = [];
        eachObj(this, function (item) {
            res.push(item);
        });
        return res;
    };
    ChartDataObj.prototype.links = function () {
        var res = [];
        eachObj(this, function (item) {
            if (item.children && item.children.length > 0) {
                item.children.map(function (child) {
                    res.push({
                        source: item,
                        target: child
                    });
                });
            }
        });
        return res;
    };
    ChartDataObj.prototype.exchangeNode = function (pNode, i, j) {
        exchangeItemSort(pNode.children, i, j);
    };
    ChartDataObj.prototype.searchNodeByID = function (id, cb) {
        searchNodeByID(this._data, id, function (node) {
            cb(node);
        });
    };
    return ChartDataObj;
}());

function resolveParams(param, defaultVal, data) {
    var res = defaultVal;
    if (typeof param === "function") {
        res = param(data);
    }
    else {
        res = param;
    }
    return res;
}
function computedCardWidth(cardModel, node) {
    cardModel.w = cardModel.w || (cardModel.col / 12 * (node.cardSize.width - 2)) || "100%";
    if (typeof cardModel.w === "string") {
        cardModel.w = parseFloat(cardModel.w) / 100 * (node.cardSize.width - 2);
    }
}
function splitByChartCode(svgTextObj, cardModel, isMinFontSize) {
    var str = svgTextObj.text;
    var wMode = cardModel.wMode || "lr";
    var fontSize = (isMinFontSize ? cardModel.minFontSize : cardModel.fontSize) + (wMode === "tb" ? 2 : 0);
    var res = [];
    var text = str[0];
    var pre = str.charCodeAt(0) > 255 ? 1 : 0;
    for (var i = 1; i < str.length; i++) {
        var currCode = 1;
        if (str.charCodeAt(i) > 255) {
            currCode = 1;
        }
        else {
            currCode = 0;
        }
        if (currCode == pre) {
            text += str[i];
        }
        else {
            res.push({
                len: pre === 1 ? fontSize * text.length : getEnWidth(text, fontSize, wMode),
                text: text,
                code: pre
            });
            text = str[i];
        }
        pre = currCode;
    }
    if (text.length > 0) {
        res.push({
            len: pre === 1 ? fontSize * text.length : getEnWidth(text, fontSize, wMode),
            text: text,
            code: pre
        });
    }
    return res;
}
//获取一段字符串的长度：length
function getEnWidth(str, fontSize, wMode) {
    var len = 6;
    for (var i = 0; i < str.length; i++) {
        len += chartCodeWidth(str[i], fontSize, 500, wMode);
    }
    return len;
}
//计算单个字符的宽度：width
function chartCodeWidth(chartCode, fontSize, fontWeight, wMode) {
    if (chartCode === void 0) { chartCode = ""; }
    if (fontSize === void 0) { fontSize = 14; }
    if (fontWeight === void 0) { fontWeight = 500; }
    if (wMode === void 0) { wMode = "tb"; }
    var width = 6;

    if (fontWeight >= 600) {
        width = fontSize / 14 * (chart_width_f600[chartCode] - (wMode === "tb" ? 1.5 : 1) || 14)
    } else {
        width = fontSize / 14 * (chart_width_f500[chartCode] - (wMode === "tb" ? 1.5 : 1) || 14);
    }

    return width;
}
//取出限定宽度内的一行字符串，并返回下标，该行字符串的宽度
//下标：在整体字符串中，该行字符串截取终点的下标
function subCurrlineText(text, start, end, width, fontSize, wMode) {
    if (wMode === void 0) { wMode = "tb"; }
    var res = "";
    var currLineTextWidth = 0;
    while (currLineTextWidth + fontSize <= width && start < end) {
        var currTextWidth = 0;
        if (text.charCodeAt(start) > 255) {
            currTextWidth = fontSize;
        }
        else {
            currTextWidth = chartCodeWidth(text[start], fontSize, 500, wMode);
        }
        if (currTextWidth + currLineTextWidth <= width) {
            res += text[start++];
            currLineTextWidth += currTextWidth;
        }
    }
    return [res, start, currLineTextWidth];
}
//将字符串切割成等宽数组
function splitStrByWidth(str, width, fontSize, fontWeight, wMode) {
    var res = [];
    var currStr = "";
    var currStrWidth = 0;
    for (var i = 0; i < str.length; i++) {
        var strItem = str[i];
        var strItemWidth = chartCodeWidth(strItem, fontSize, fontWeight, wMode);
        if (currStrWidth < width) {
            if ((currStrWidth + strItemWidth) < width);
            else {
                res.push(currStr);
                currStr = "";
                currStrWidth = 0;
            }
            currStr += strItem;
            currStrWidth += strItemWidth;
        }
        else {
            console.error("默认宽度不够");
            break;
        }
    }
    res.push(currStr);
    return res;
}
//计算组合字符串
function subCurrlineComposeText(mainText, suffixText, start, end, width, fontSize, wMode) {
    var suffixTextWidth = 0;
    for (var i = 0; i < suffixText.length; i++) {
        if (suffixText.charCodeAt(i) > 255) {
            suffixTextWidth += fontSize;
        }
        else {
            suffixTextWidth += chartCodeWidth(suffixText[i], fontSize);
        }
    }
    var _a = subCurrlineText(mainText, start, end, width - suffixTextWidth, fontSize, wMode), currLineMainText = _a[0], lsStart = _a[1];
    start = lsStart;
    currLineMainText = currLineMainText.substr(0, currLineMainText.length - 1) + "…" + suffixText;
    return currLineMainText;
}
//计算卡片节点偏移坐标
function getNodePaintLoc(currNode, baseCardSize, type, scale) {
    if (type === void 0) { type = "normal"; }
    if (scale === void 0) { scale = 1; }
    if (type === "normal") {
        if (currNode.isLeaf) {
            return "translate( " + (currNode.x - baseCardSize.width / 2) * scale + ", " + (currNode.y - currNode.cardSize.height / 2) * scale + ")";
        }
        else {
            return "translate( " + (currNode.x - currNode.cardSize.width / 2) * scale + ", " + (currNode.y - baseCardSize.height / 2) * scale + ")";
            // return `translate( ${(currNode.x - baseCardSize.width / 2) * scale}, ${(currNode.y - baseCardSize.height / 2) * scale})`
        }
    }
    else {
        return "translate(" + (currNode.x0 - baseCardSize.width / 2) * scale + "," + (currNode.y0 - baseCardSize.height / 2) * scale + ")";
    }
}
//一段字符串绘制在svg上，需要自行计算换行
//将一段字符串分割成若干段，组成数据
//算出每段字符串的坐标：x、y   内容：text  长度：len
function computedTextList(cardModel, node) {
    var textDoms = [];
    //文字参数
    var texts = cardModel.text(node.data);
    var isEllipsis = false;
    var valign = cardModel.valign || "center"; //top center
    var textAnchor = cardModel.textAnchor || "start"; //start middle end
    var lineSpacing = cardModel.lineSpacing || 0;
    var fontSize = cardModel.fontSize;
    var fongHeight = fontSize + 4; //文字高度
    var cardModelWidth = parseInt(cardModel.w + '');
    var textLineWidth = 0;
    var wMode = cardModel.wMode || "lr";
    var isMinFontSize = false;
    var lineNums = 1;
    cardModel.minFontSize = cardModel.minFontSize || 12;
    if (wMode === "tb") {
        textLineWidth = cardModel.h;
        fontSize += 2.75;
        lineNums = Math.floor(cardModelWidth / fontSize);
    }
    else {
        textLineWidth = cardModelWidth;
        fontSize += 0.5;
        lineNums = Math.floor(cardModel.h / fontSize);
    }

    var arraySpacing = 0;
    texts.map(function (text, index) {
        text = text || "（空）";
        var textInfo = text;
        var isCompose = typeof text === "object";
        if (isCompose) {
            textInfo = text.mainText + text.suffixText;
        }
        var start = 0;
        var end = textInfo.length;
        var currLine = 0;
        if (lineNums > 0) {
            while (start < textInfo.length) {
                currLine++;
                var _a = subCurrlineText(textInfo, start, end, textLineWidth, fontSize, wMode), currLineText = _a[0], lsStart = _a[1], currLineTextWidth = _a[2];
                // 最后一行
                if (currLine === lineNums) {
                    //还剩下文字
                    if (lsStart < textInfo.length) {
                        isEllipsis = true;
                        node.isEllipsis = true;
                        if (isCompose) {
                            currLineText = subCurrlineComposeText(text.mainText, text.suffixText, start, end, textLineWidth, fontSize, wMode);
                        }
                        else {
                            start = lsStart;
                            currLineText = currLineText.substr(0, currLineText.length - 1) + "…";
                        }
                    }
                    //最后一行，退出循环
                    start = Infinity;
                } else {
                    start = lsStart;
                }
                if (wMode === "tb") {
                    textDoms.push({
                        text: currLineText,
                        x: 0,
                        y: index === 0 ? 0 : arraySpacing,
                        len: currLineTextWidth
                    });
                } else {
                    textDoms.push({
                        text: currLineText,
                        x: 0,
                        y: index === 0 ? 0 : arraySpacing,
                        len: currLineTextWidth
                    });
                }

            }
        }
    });

    for (var i = 0; i < textDoms.length; i++) {
        var x = 0;
        var y = 0;
        // 场景单调，文字居中即可
        if (wMode === "tb") {
            var shiftX = (cardModelWidth - textDoms.length * fontSize) / 2;
            var shiftY = 0;
            if (valign === "center") {
                shiftY = (cardModel.h - textDoms[i].len) / 2;
            }
            x = fongHeight / 2 + cardModel.x + shiftX + fongHeight * i;
            y = cardModel.y + shiftY;
        }
        else {
            var shiftY = 0;
            var shiftX = 0;
            if (valign === "center") {
                shiftY = (cardModel.h - textDoms.length * fongHeight - (textDoms.length - 1) * lineSpacing - (texts.length - 1) * arraySpacing) / 2;
            }
            switch (textAnchor) {
                case "start":
                    x = cardModel.x + shiftX;
                    break;
                case "middle":
                    shiftX = (cardModelWidth - textDoms[i].len) / 2;
                    x = cardModel.x + shiftX;
                    break;
                case "end":
                    x = cardModelWidth - textDoms[i].len + cardModel.x;
                    break;
            }
            y = cardModel.y + (isMinFontSize ? cardModel.minFontSize : cardModel.fontSize) + shiftY + (fongHeight + lineSpacing) * i;
        }
        textDoms[i].x += x;
        textDoms[i].y += y;
    }

    return [textDoms, isEllipsis, isMinFontSize];
}
//计算一段字符串的宽度
//文字text SVGDOM
function card2Text(cardModel, node, g) {
    var _a;
    var _b = computedTextList(cardModel, node), textDoms = _b[0], isEllipsis = _b[1], isMinFontSize = _b[2];
    if (textDoms.length <= 0)
        return [null, false]
    var fontWeight = cardModel.fontWeight || 500;
    var color = resolveParams(cardModel.color, "#fff", node.data);
    var wMode = cardModel.wMode || "lr";
    var offsetX = 0;
    var lastFontSize = isMinFontSize ? cardModel.minFontSize : cardModel.fontSize;
    var display = (cardModel.showType === "hover") ? "none" : "";
    var text = d3.create("svg:text")
        .attr("writing-mode", wMode)
        .attr("fill", color)
        .attr("xml:space", "preserve")
        .attr("text-anchor", "start")
        .attr("font-size", lastFontSize)
        .attr("font-weight", fontWeight)
        .attr("style", "display:" + display)
        .attr("class", "card2" + node.id + "2" + ((_a = cardModel.showType) !== null && _a !== void 0 ? _a : ""));

    textDoms.map(function (T, i) {
        var spanTexts = splitByChartCode(T, cardModel, isMinFontSize);
        var prelen = 0;
        spanTexts.map(function (spanItem, j) {
            var span = text.append("svg:tspan")
                .text(spanItem.text)
                .attr("x", T.x + offsetX + (wMode === "lr" ? prelen : 0))
                .attr("y", T.y + (wMode === "tb" ? prelen : 0))
                .attr("font-family", SVGFontFamily)
                .attr("word-spacing", 0)
                .attr("letter-spacing", 0)
                .attr("class", "span" + node.id + i + j);
            prelen += spanItem.len;
            if (spanItem.code === 1) {
                //中文
                span.attr("textLength", spanItem.len);
            }
            else {
                //非中
                span.attr("textLength-show", spanItem.len);
                // span.attr("letter-spacing", 0)
            }
        });
    });
    return [text, isEllipsis];
}
function paintTextRect(textInfo, cardModel, fontSize) {
    var offsetY = 12;
    var width = 200;
    var w = 0;
    var h = 0;
    var strArr = splitStrByWidth(textInfo, width, fontSize, 500, cardModel.wMode);
    var x = cardModel.x;
    var y = cardModel.y - offsetY / 2 - 1;
    var text = d3.create("svg:text")
        .attr("x", x)
        .attr("y", y)
        .attr("fill", "#333")
        .attr("xml:space", "preserve")
        .attr("text-anchor", "start")
        .attr("font-size", fontSize);
    for (var i = 0; i < strArr.length; i++) {
        var str = strArr[i];
        text.append("svg:tspan")
            .text(str)
            .attr("x", x)
            .attr("y", y + i * (fontSize + 5))
            .attr("font-family", SVGFontFamily)
            .attr("word-spacing", 0)
            .attr("letter-spacing", 0);
    }
    h = ((fontSize + 5) * strArr.length + offsetY);
    w = width + fontSize * 1.5;
    return [
        d3.create("svg:rect")
            .attr("width", w)
            .attr("height", h)
            .attr("x", cardModel.x - fontSize / 2)
            .attr("y", cardModel.y - fontSize - offsetY)
            .attr("rx", 2)
            .attr("fill-opacity", 1)
            .attr("fill", "#fff")
            .attr("stroke", "#000")
            .attr("stroke-opacity", 1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto"),
        text
        // d3.create("svg:text")
        //     .text(textInfo)
        //     .attr("x", cardModel.x)
        //     .attr("y", cardModel.y - offsetY / 2 - 1)
        //     .attr("fill", "#333")
        //     .attr("xml:space", "preserve")
        //     .attr("text-anchor", "start")
        //     .attr("font-size", fontSize)
    ];
}
//矩形rect SVGDOM
function paintRect(node, g) {
    var rect = d3.create("svg:rect")
        .attr("class", "card-wrapper")
        .attr("width", node.cardSize.width)
        .attr("height", node.cardSize.height)
        .attr("rx", node.cardStyle.radius || 2)
        .attr("fill-opacity", 1)
        .attr("fill", node.cardStyle.background)
        .attr("stroke", node.cardStyle.border)
        .attr("stroke-dasharray", node.cardStyle.borderType)
        .attr("stroke-linecap", "round")
        .attr("stroke-opacity", 1)
        .attr("stroke-width", 1)
        .attr("shape-rendering", "auto");
    rect.node()["__data__"] = node;
    g.appendChild(rect.node());
}
function getMigConfig(cardModel) {
    var boxW = parseInt(cardModel.w + '');
    var textAnchor = cardModel.textAnchor || "start"; //start middle end
    var imgSize = Math.min(boxW, cardModel.h);
    var x = cardModel.x;
    switch (textAnchor) {
        case "start":
            break;
        case "middle":
            x += (boxW - imgSize) / 2;
            break;
        case "end":
            x = boxW - imgSize;
            break;
    }
    return [imgSize, x];
}
//图片img
function card2img(cardModel, clipId, node, imgId, imgSize, x) {
    var img = d3.create("svg:image")
        .attr("id", imgId)
        .attr("xlink:href", cardModel.url(node.data))
        .attr("width", imgSize)
        .attr("height", imgSize)
        .attr("x", x)
        .attr("y", cardModel.y)
        .attr("clip-path", "url(#" + clipId + ")");
    return img;
}
//切割图片
function getClipPath(clipId, locSize, rx, imgSize, x) {
    var defs = d3.create("svg:defs");
    var rectId = "imgRect" + clipId;
    // defs.appendChild("rect")
    //     .attr("id", rectId)
    //     .attr("x", locSize.x)
    //     .attr("y", locSize.y)
    //     .attr("width", locSize.w)
    //     .attr("height", locSize.h)
    //     .attr("rx", rx)
    var r = imgSize / 2;
    defs.append("circle")
        .attr("id", rectId)
        .attr("cx", x + r)
        .attr("cy", locSize.y + r)
        .attr("r", r)
        .attr("stroke", "#f00")
        .attr("stroke-width", 2);
    defs.append("clipPath")
        .attr("id", clipId)
        .append("use")
        .attr("xlink:href", "#" + rectId);
    return defs;
}
//字体图标
function card2icon(cardModel, node) {
    return d3.create("svg:text")
        .html(cardModel.text(node.data) + '')
        .attr("class", "icon manhead-icon " + cardModel.class)
        .attr("font-size", cardModel.fontSize)
        .attr("fill", cardModel.fill)
        .attr("x", cardModel.x)
        .attr("y", cardModel.y);
}
//矩形
function card2rect(cardModel, node) {
    return d3.create("svg:rect")
        .attr("x", cardModel.x)
        .attr("y", cardModel.y)
        .attr("class", cardModel.class || "")
        .attr("rx", cardModel.rx)
        .attr("width", cardModel.w)
        .attr("height", cardModel.h)
        .attr("fill", resolveParams(cardModel.fill, "#fff", node.data))
        .attr("stroke", resolveParams(cardModel.stroke, "#fff", node.data))
        .attr("stroke-opacity", cardModel.strokeOpacity || 1)
        .attr("shape-rendering", "crispEdges");
}
//圆形⚪
function card2circle(cardModel, node) {
    return d3.create("svg:circle")
        .attr("r", cardModel.r)
        .attr("cx", cardModel.x)
        .attr("cy", cardModel.y)
        .attr("class", cardModel.class || "")
        .attr("fill", resolveParams(cardModel.fill, "#fff", node.data))
        .attr("stroke", resolveParams(cardModel.stroke, "#fff", node.data))
        .attr("stroke-opacity", cardModel.strokeOpacity || 1);
    // .attr("shape-rendering", "crispEdges")
}
//线条
function card2path(cardModel) {
    return d3.create("svg:path")
        .attr("class", "infoLine")
        .attr("d", "M" + cardModel.x + "," + cardModel.y + " H" + (cardModel.x + parseInt(cardModel.w + '')))
        .attr("fill-opacity", 0)
        .attr("stroke-width", 0.5)
        .attr("stroke", cardModel.stroke)
        .attr("shape-rendering", "crispEdges");
}
function computedArea(p1, p2) {
    var baseCardSize = p2.cardSize;
    var p1Size = p1.cardSize;
    var p2Size = p2.cardSize;
    if ((Math.abs(p1.x - p2.x) >= (p1Size.width + p2Size.width) / 2) || (Math.abs(p1.y - p2.y) >= (p1Size.height + p2Size.height) / 2))
        return 0;
    var target = p1;
    var source = p2;
    if (p1.x - p2.x > 0) {
        target = p2;
        source = p1;
    }
    var width = target.x + baseCardSize.width - source.x;
    var height = 0;
    if (source.y > target.y) {
        height = source.y + baseCardSize.height - target.y;
    }
    else {
        height = target.y + baseCardSize.height - source.y;
    }
    return width * height;
}
function getMaxAreaID(d, baseCardSize) {
    var maxArea = 0;
    var maxareaNode = null;
    if (d.parent) {
        var list = __spreadArray([d.parent], d.parent.children); //拖拽至脖子位置
        // let list = [...d.parent.children]
        list.map(function (node) {
            if (d.id !== node.id) {
                var area = computedArea(d, node);
                if (area > maxArea) {
                    maxArea = area;
                    maxareaNode = node;
                }
                if (maxArea <= 0) {
                    maxareaNode = null;
                }
            }
        });
    }
    return maxareaNode;
}
function delItem(list, item) {
    var index = -1;
    for (var i = 0; i < list.length; i++) {
        if (list[i].id === item.id) {
            index = i;
            break;
        }
    }
    list.splice(index, 1);
}
function pushItem(list, item) {
    var index = -1;
    for (var i = 0; i < list.length; i++) {
        if (list[i].id === item.id) {
            index = i;
            break;
        }
    }
    if (index === -1) {
        list.push(item);
    }
}

var ChartCardObj = /** @class */ (function () {
    function ChartCardObj(manViewObj) {
        this.manViewObj = manViewObj;
        this.initParams();
    }
    ChartCardObj.prototype.initParams = function () {
        this.selectedCard = [];
        this.gNode = this.manViewObj.group.append("g")
            .attr("cursor", "pointer")
            .attr("pointer-events", "visible");
    };
    ChartCardObj.prototype.initPaint = function (currNode, rePaintInfo) {
        if (rePaintInfo === void 0) { rePaintInfo = true; }
        var baseCardSize = this.manViewObj.kdChartObj.cardConfig.baseCardSize;
        this.nodes = this.manViewObj.kdChartObj.chartData.data.getNodes().reverse();
        var transition = this.manViewObj.group.transition().duration(500);
        var nodeGroup = this.gNode.selectAll("g")
            .data(this.nodes, function (d) { return d["id"]; });
        var nodeEnter = nodeGroup.enter().append("g")
            .attr("class", function (d) { return "card-group card2" + d.id; })
            .attr("transform", getNodePaintLoc(currNode, baseCardSize, "init"));
        this.bindCardEvent(nodeEnter);
        this.nodeUpdate = nodeGroup.merge(nodeEnter)
            .transition(transition)
            .attr("transform", function (node) { return getNodePaintLoc(node, baseCardSize); })
            .attr("fill-opacity", 1)
            .attr("stroke-opacity", 1);
        nodeGroup.exit().transition(transition).remove()
            .attr("transform", getNodePaintLoc(currNode, baseCardSize))
            .attr("stroke-opacity", 0)
            .attr("fill-opacity", 0);
        if (rePaintInfo) {
            this.paintInfo();
        }
        this.manViewObj.kdChartObj.chartData.syncLoc();
    };
    ChartCardObj.prototype.resetPaint = function (currNode, rePaintInfo) {
        if (rePaintInfo === void 0) { rePaintInfo = true; }
        //rePaintInfo 是否重新绘制内容（有新的卡片的时候，如：展开）
        this.initPaint(currNode, rePaintInfo);
    };
    ChartCardObj.prototype.bindCardEvent = function (nodeEnter) {
        var _this = this;
        nodeEnter
            .call(d3.drag()
                .on("start", function (e, d) {
                    // 排除折叠按钮
                    if (e.sourceEvent.target.className.baseVal.indexOf("op-icon") > -1)
                        return;
                    //是否编辑态
                    if (!_this.manViewObj.kdChartObj.editStatus)
                        return;
                    // 移动卡片删除 && 添加    =>  卡片处于顶层
                    var currDom = document.getElementsByClassName("card2" + d["id"])[0];
                    var currParent = currDom.parentNode;
                    currDom.remove();
                    //绘制残影（虚框）
                    _this.manViewObj.cardShadow.showCardShadow(d, currParent);
                    currParent.appendChild(currDom);
                })
                .on("drag", function (e, d) {
                    // 排除折叠按钮
                    if (e.sourceEvent.target.className && e.sourceEvent.target.className.baseVal.indexOf("op-icon") > -1)
                        return;
                    //是否编辑态
                    if (!_this.manViewObj.kdChartObj.editStatus)
                        return;
                    // 卡片在移动中,设置移动的状态
                    _this.moving = true;
                    // 移动卡片
                    _this.dragNode(e, d);
                })
                .on("end", function (e, d) {
                    //  排除折叠按钮
                    if (e.sourceEvent.target.className.baseVal.indexOf("op-icon") > -1)
                        return;
                    //  是否编辑态
                    if (!_this.manViewObj.kdChartObj.editStatus)
                        return;
                    //  卡片处于编辑态 && 卡片在移动中 => 卡片移动结束
                    //删除残影（虚框）
                    _this.manViewObj.cardShadow.delCardShadow();
                    if (_this.moving) {
                        _this.dragNode(e, d, 2);
                        _this.moving = false;
                        _this.selectedCard = [];
                    }
                    else {
                        //  点击事件
                        _this.clickCard(d, e);
                    }
                })
                .filter(function (e) { return e.target.className.baseVal === "card-wrapper"; }))
            .on("mousemove", function (e, node) {
                _this.CardModelHoverDomMove(node);
            })
            .on("mouseout", function (e, node) {
                _this.CardModelHoverDomOut(node);
            });
    };
    ChartCardObj.prototype.CardModelHoverDomMove = function (node) {
        //  是否编辑态
        if (!this.manViewObj.kdChartObj.editStatus)
            return;
        //  是否已经hover显示
        if (node.hoverStatus)
            return;
        node.hoverStatus = true;
        d3.select(".card2" + node.id + "2hover").attr("style", "");
    };
    ChartCardObj.prototype.CardModelHoverDomOut = function (node) {
        //  是否编辑态
        if (!this.manViewObj.kdChartObj.editStatus)
            return;
        node.hoverStatus = false;
        d3.select(".card2" + node.id + "2hover").attr("style", "display:none");
    };
    ChartCardObj.prototype.clickCard = function (d, e) {
        if (d3.select(".card2" + d.id).classed("ghover")) {
            d3.select(".card2" + d.id).classed("ghover", false);
            delItem(this.selectedCard, d);
        }
        else {
            d3.select(".card2" + d.id).classed("ghover", true);
            pushItem(this.selectedCard, d);
        }
    };
    //dragStatus  1:移动  2:结束
    ChartCardObj.prototype.dragNode = function (e, d, dragStatus) {
        if (dragStatus === void 0) { dragStatus = 1; }
        d.x += e.dx;
        d.y += e.dy;
        var maxareaNode = getMaxAreaID(d, this.manViewObj.kdChartObj.cardConfig.baseCardSize);
        //拖拽中
        if (dragStatus === 1) {
            this.moveNode(d);
            d3.selectAll("g.ghover").classed("ghover", false);
            if (maxareaNode !== null) {
                if (d.parent.id === maxareaNode.id || (maxareaNode.isLeaf || false) === (d.isLeaf || false)) {
                    d3.select(".card2" + maxareaNode.id).classed("ghover", true);
                }
            }
            this.manViewObj.sortCard.delSortCard();
            if (maxareaNode !== null && (maxareaNode.isLeaf || false) === (d.isLeaf || false)) {
                this.manViewObj.sortCard.showSortCard(d, maxareaNode);
            }
        }
        //拖拽结束
        if (dragStatus === 2) {
            this.manViewObj.sortCard.delSortCard();
            d3.selectAll("g.ghover").classed("ghover", false);
            if (maxareaNode !== null && d.parent.id === maxareaNode.id) {
                console.log("更改挂载");
                var res = this.changeNodeLoad(d);
                if (!res) {
                    console.log("更改失败");
                    d.x = d.x0;
                    d.y = d.y0;
                    this.moveNode(d, 2);
                }
            }
            else if (maxareaNode !== null && (maxareaNode.isLeaf || false) === (d.isLeaf || false)) {
                console.log("修改排序");
                this.exchangeNode(d, maxareaNode);
            }
            else {
                console.log("不做变更");
                d.x = d.x0;
                d.y = d.y0;
                this.moveNode(d, 2);
            }
        }
    };
    //修改卡片顺序
    ChartCardObj.prototype.exchangeNode = function (node, maxareaNode) {
        var i = -1; //挪动的节点
        var j = -1; //挪动节点的目标节点
        node.parent.children.map(function (citem, index) {
            if (citem.id === node.id) {
                i = index;
            }
            if (citem.id === maxareaNode.id) {
                j = index;
            }
        });
        this.manViewObj.kdChartObj.treeData.exchangeItem(node.parent.id, i, j);
        this.manViewObj.kdChartObj.chartData.exchangeNode(node.parent, i, j);
        this.manViewObj.sortRecord.push({
            pNode: node.parent,
            i: i,
            j: j
        });
        this.manViewObj.kdChartObj.chartData.resetChartData();
        this.manViewObj.resetPaint(node);
    };
    ChartCardObj.prototype.moveNode = function (d, dragStatus) {
        //被移动的节点坐标变更
        d3.select(".card2" + d.id).attr("transform", getNodePaintLoc(d, this.manViewObj.kdChartObj.cardConfig.baseCardSize));
        //同步处理连线
        // this.manViewObj.chartPath.resetPaint2moveNode([d.id], dragStatus)
    };
    //修改卡片挂载
    ChartCardObj.prototype.changeNodeLoad = function (node) {
        var canChange = true;
        if (node.isLeaf);
        else {
            // //变成叶子
            // //有子节点，不能作为叶子
            if (node.children && node.children.length > 0) {
                canChange = false;
            }
        }
        if (canChange) {
            this.manViewObj.kdChartObj.treeData.changeNodeLoad(node.id);
            this.manViewObj.kdChartObj.chartData.resetChartData();
            this.manViewObj.resetPaint(node);
            this.manViewObj.loadRecord.push(node);
        }
        return canChange;
    };
    ChartCardObj.prototype.paintInfo = function () {
        var _this = this;
        this.nodeUpdate._groups[0].map(function (g) {
            var d = g.__data__;
            if (_this.manViewObj.isInPaintView(d)) {
                if (g.childNodes.length <= 0 || d.cardChange) {
                    g.innerHTML = "";
                    //卡片矩形框
                    paintRect(d, g);
                    //填充卡片内容包括不限：文字、图案、线条、矩形、圆形、字体图标等
                    _this.paintCardInfo(d, g).map(function (resDom) {
                        g.appendChild(resDom.node());
                    });
                }
                _this.paintToggle(d, g);
                // this.paintDrillUp(d, g)
            }
            else {
                if (g.childNodes.length > 0) {
                    //清空内容
                    g.innerHTML = "";
                }
            }
        });
    };
    ChartCardObj.prototype.paintCardInfo = function (node, g) {
        var _this = this;
        var resDom = [];
        var cardModels = this.manViewObj.cardModel[node.cardModel] || [];
        cardModels.map(function (cardModel, index) {
            computedCardWidth(cardModel, node);
            var show = true;
            if (cardModel.showFlag) {
                show = cardModel.showFlag(node);
            }
            if (show) {
                switch (cardModel.tag) {
                    case "text":
                        var _a = card2Text(cardModel, node), dom = _a[0], isEllipsis = _a[1];
                        if (dom) {
                            _this.domBindClick(cardModel, dom, node);
                            resDom.push(dom);
                        }
                        if (isEllipsis) {
                            _this.setTextTips(dom, cardModel, node);
                        }
                        break;
                    case "img":
                        var clipId = "clip" + node.id + index;
                        var imgId = "img" + node.id + index;
                        var _b = getMigConfig(cardModel), imgSize = _b[0], x = _b[1];
                        resDom.push(getClipPath(clipId, cardModel, cardModel.rx, imgSize, x));
                        resDom.push(card2img(cardModel, clipId, node, imgId, imgSize, x));
                        break;
                    case "rect":
                        resDom.push(card2rect(cardModel, node));
                        break;
                    case "circle":
                        resDom.push(card2circle(cardModel, node));
                        break;
                    case "path":
                        resDom.push(card2path(cardModel));
                        break;
                    case "icon":
                        resDom.push(card2icon(cardModel, node));
                        break;
                }
            }
        });
        return resDom;
    };
    ChartCardObj.prototype.domBindClick = function (cardModel, dom, node) {
        var _this = this;
        dom.on("click", function () {
            // 是否是编辑态
            // if (this.manViewObj.kdChartObj.editStatus) {
            //     if (cardModel.tag === "text") {
            //         console.log(cardModel, node);
            //     }
            // } else {
            //     cardModel.click && cardModel.click(node, this.manViewObj.kdChartObj)
            // }
            cardModel.click && cardModel.click(node, _this.manViewObj.kdChartObj);
        });
    };
    ChartCardObj.prototype.setTextTips = function (dom, cardModel, node) {
        var _this = this;
        if (!this.manViewObj.config.textTips)
            return;
        var fontSize = 12;
        var textInfo = cardModel.text(node.data).reduce(function (t1, t2) { return t1 + "" + t2; });
        var _a = paintTextRect(textInfo, cardModel, fontSize), rectDom = _a[0], textDom = _a[1];
        dom
            .on("mousemove", function (e) {
                if (_this.manViewObj.kdChartObj.editStatus)
                    return;
                _this.manViewObj.tipsCard.showTipsGroup({ x: node.x, y: node.y }, [rectDom, textDom]);
            })
            .on("mouseout", function () {
                if (_this.manViewObj.kdChartObj.editStatus)
                    return;
                _this.manViewObj.tipsCard.hideTipsGroup();
            });
    };
    ChartCardObj.prototype.paintToggle = function (node, g) {
        var _this = this;
        if (!this.manViewObj.config.toogleBtn || !node.hasChild)
            return;
        var iconConfig = this.manViewObj.iconConfig;
        var r = iconConfig.fontSize / 2; //按钮半径
        var rootDepth = this.manViewObj.kdChartObj.chartData.data.depth;
        var cx = node.cardSize.width / 2; //按钮x坐标
        var cy = 0; //按钮y坐标
        var islastLevel = node.depth - rootDepth === (this.manViewObj.kdChartObj.cardConfig.limitLevel - 1);
        // 禁止向下拓展
        if (islastLevel)
            return;
        // 根据图的方向，摆放折叠按钮
        switch (this.manViewObj.kdChartObj.viewConfig.direction) {
            case 1:
                cy = node.cardSize.height + r * 2;
                break;
            case 2:
                cy = node.cardSize.height / 2 + r - 2;
                cx = node.cardSize.width + r;
                break;
            case 3:
                cy = -r;
                break;
            case 4:
                cy = node.cardSize.height / 2 + r - 2;
                cx = -r;
                break;
        }
        // 添加折叠按钮
        var isOpen = node.hasChild && !!node.children && node.children.length > 0;
        var iconType;
        var opType = 1; //1.toogle 2.drill
        if (islastLevel) {
            iconType = iconConfig.drillDown;
            opType = 2;
        }
        else {
            iconType = isOpen ? iconConfig.toogleMinus : iconConfig.tooglePlus;
            opType = 1;
        }
        var hadIcon = d3.select("#tgBtnID" + node.id);
        if (hadIcon["_groups"][0][0] !== null) {
            hadIcon
                .html(iconType.unicode)
                .attr("fill", iconType.color)
                .on("click", function () {
                    _this.beforeToogleNode(node, opType);
                });
        }
        else {
            g.appendChild(this.iconMaskCircle(r, cx, cy).node());
            var icon = d3.create("svg:text")
                .html(iconType.unicode)
                .attr("class", "op-icon " + iconConfig.class)
                .attr("id", "tgBtnID" + node.id)
                .attr("x", cx - r)
                .attr("y", cy)
                .attr("font-size", 2 * r)
                .attr("fill", iconType.color)
                .on("click", function () {
                    _this.beforeToogleNode(node, opType);
                });
            icon.node()["__data__"] = node;
            g.appendChild(icon.node());
        }
    };
    ChartCardObj.prototype.iconMaskCircle = function (r, cx, cy) {
        return d3.create("svg:circle")
            .attr("r", r - 2)
            .attr("cx", cx)
            .attr("cy", cy - r)
            .attr("fill", "#fff")
            .attr("stroke-opacity", 0)
            .attr("shape-rendering", "crispEdges");
    };
    //补充数据
    ChartCardObj.prototype.beforeToogleNode = function (node, opType) {
        var _this = this;
        if (!this.manViewObj.config.toogleBtn)
            return;
        //是否折叠
        var fold = node.children && node.children.length > 0;
        //存在下级，未获取数据，异步补充数据
        if (node.hasChild && !node._children) {
            this.manViewObj.kdChartObj.treeData.supplyChildData(node.id)
                .then(function () {
                    return _this.manViewObj.kdChartObj.chartData.supplyChildData(node);
                })
                .then(function () {
                    _this.toogleNode(node, fold, opType);
                });
        }
        else {
            this.toogleNode(node, fold, opType);
        }
    };
    //fold true:折叠  false:展开
    //opType 1：折叠  2：拓展（上下钻）
    ChartCardObj.prototype.toogleNode = function (node, fold, opType) {
        if (fold) {
            //折叠
            //处理treeData
            this.manViewObj.kdChartObj.treeData.foldData(node);
            //处理chartData
            this.manViewObj.kdChartObj.chartData.foldData(node);
            //处理按钮
            this.foldCard(node);
        }
        else {
            //展开
            //处理treeData
            this.manViewObj.kdChartObj.treeData.openData(node);
            //如果是拓展操作，需要更改顶层
            if (opType == 2) {
                this.manViewObj.kdChartObj.chartData.changeRoot(node);
                this.manViewObj.kdChartObj.treeData.changeRoot(this.manViewObj.kdChartObj.chartData.data.id);
            }
            //处理chartData
            this.manViewObj.kdChartObj.chartData.openData(node);
            //处理按钮
            this.openCard(node);
        }
        this.manViewObj.kdChartObj.chartData.resetChartData();
        this.manViewObj.resetPaint(node, !fold);
    };
    ChartCardObj.prototype.foldCard = function (node) {
        d3.select("#tgBtnID" + node.id)
            .html(this.manViewObj.iconConfig.tooglePlus.unicode)
            .attr("fill", this.manViewObj.iconConfig.tooglePlus.color);
    };
    ChartCardObj.prototype.openCard = function (node) {
        d3.select("#tgBtnID" + node.id)
            .html(this.manViewObj.iconConfig.toogleMinus.unicode)
            .attr("fill", this.manViewObj.iconConfig.toogleMinus.color);
    };
    ChartCardObj.prototype.limitChildLevel = function (node, level) {
        var _this = this;
        //展开
        if (level > 0) {
            node.children = node._children;
            node.children && node.children.map(function (cnode) {
                _this.limitChildLevel(cnode, level - 1);
            });
        }
        else {
            node.children = null;
        }
    };
    ChartCardObj.prototype.paintDrillUp = function (node, g) {
        var _this = this;
        if (node.id === this.manViewObj.kdChartObj.chartData.data.id && node.hasParent) {
            var iconConfig = this.manViewObj.iconConfig;
            var r = iconConfig.fontSize / 2; //按钮半径
            var cx = node.cardSize.width / 2 - r; //按钮x坐标
            var cy = -r; //按钮y坐标
            g.appendChild(this.iconMaskCircle(r, cx + r, cy).node());
            var icon = d3.create("svg:text")
                .html(iconConfig.drillup.unicode)
                .attr("class", "op-icon " + iconConfig.class)
                .attr("id", "drillUpBtnID" + node.id)
                .attr("x", cx)
                .attr("y", cy)
                .attr("font-size", 2 * r)
                .attr("fill", iconConfig.drillup.color)
                .on("click", function () {
                    _this.beforeDrillUpNode(node);
                });
            icon.node()["__data__"] = node;
            g.appendChild(icon.node());
        }
        else {
            var icon = d3.select("#drillUpBtnID" + node.id);
            icon && icon.remove();
        }
    };
    ChartCardObj.prototype.beforeDrillUpNode = function (node) {
        var _this = this;
        var isSyncData = node.hasParent && !!node.parent;
        this.manViewObj.kdChartObj.treeData.supplyParentData(node.id, isSyncData)
            .then(function () {
                return _this.manViewObj.kdChartObj.chartData.supplyParentData(node.id);
            })
            .then(function () {
                _this.drillUpNode(node);
            });
    };
    ChartCardObj.prototype.drillUpNode = function (node) {
        this.manViewObj.resetPaint(node);
    };
    return ChartCardObj;
}());

function getInitElbow(currNode, scale) {
    if (scale === void 0) { scale = 1; }
    var sourceSize = currNode.cardSize;
    var _a = [currNode.x0 * scale, currNode.y0 * scale], sourceX = _a[0], sourceY = _a[1];
    return ('M' + sourceX + ',' + (sourceY + sourceSize.height * scale / 2 + 4) + ' V' + sourceY + ' H' + sourceX + ' V' + sourceY);
}
function getElbow(path, scale, direction, elbowRatio, getPathScheme, baseCardSize) {
    // let sourceSize = path.source.cardSize
    var targetSize = path.target.cardSize;
    // let [sourceX, sourceY] = [path.source.x * scale, path.source.y * scale * (direction ? -1 : 1)]
    // let [targetX, targetY] = [path.target.x * scale, path.target.y * scale * (direction ? -1 : 1)]
    var _a = [path.source.x * scale, path.source.y * scale], sourceX = _a[0], sourceY = _a[1];
    var _b = [path.target.x * scale, path.target.y * scale], targetX = _b[0], targetY = _b[1];
    if (getPathScheme) {
        return getPathScheme(path, scale, baseCardSize, direction);
    }
    else {
        if (path.target.isLeaf) {
            return ('M' + sourceX + ',' + sourceY + ' V' + (targetY + targetSize.height * scale / 2) + ' H' + targetX);
        }
        else {
            return ('M' + (sourceX) + ',' + (sourceY + baseCardSize.height * scale / 2) + ' V' + (targetY + sourceY) / 2 + ' H' + targetX + ' V' + (targetY - baseCardSize.height * scale / 2));
        }
    }
}
function getEndElbow(currNode, scale) {
    if (scale === void 0) { scale = 1; }
    var sourceSize = currNode.cardSize;
    var _a = [currNode.x * scale, currNode.y * scale], sourceX = _a[0], sourceY = _a[1];
    return ('M' + sourceX + ',' + (sourceY + sourceSize.height * scale / 2 + 4) + ' V' + sourceY + ' H' + sourceX + ' V' + sourceY);
}
function moveElbow(path, scale, direction) {
    if (scale === void 0) { scale = 1; }
    var sourceSize = path.source.cardSize;
    var targetSize = path.target.cardSize;
    var _a = [path.source.x * scale, path.source.y * scale + sourceSize.height * scale / 2], sourceX = _a[0], sourceY = _a[1];
    var _b = [path.source.x0 * scale, path.source.y0 * scale + sourceSize.height * scale / 2], middleX = _b[0], middleY = _b[1];
    var _c = [path.target.x * scale, path.target.y * scale - targetSize.height * scale / 2], targetX = _c[0], targetY = _c[1];
    // let [sourceX, sourceY] = [path.source.x * scale, path.source.y * scale + sourceSize.height * scale / 2 * (direction ? -1 : 1)]
    // let [middleX, middleY] = [path.source.x0 * scale, path.source.y0 * scale + sourceSize.height * scale / 2 * (direction ? -1 : 1)]
    // let [targetX, targetY] = [path.target.x * scale, path.target.y * scale - targetSize.height * scale / 2 * (direction ? -1 : 1)]
    var offsetY = targetY - middleY;
    return ('M' + sourceX + ',' + sourceY + ' V' + middleY + ' H' + middleX + ' V' + (targetY - offsetY / 2) + ' H' + targetX + ' V' + targetY);
}

var ChartPathObj = /** @class */ (function () {
    function ChartPathObj(manViewObj) {
        this.manViewObj = manViewObj;
        this.initParams();
    }
    ChartPathObj.prototype.initParams = function () {
        //连线颜色
        this.pathTheme = {
            stroke: "#ccc",
            activeStroke: "#f38"
        };
        this.gLink = this.manViewObj.group.append("g")
            .attr("class", "pathGroup")
            .attr("fill", "none");
        this.upStep = PathUpStep;
    };
    ChartPathObj.prototype.initPaint = function (currNode, rePaintPath) {
        var _this = this;
        if (rePaintPath === void 0) { rePaintPath = false; }
        this.links = this.manViewObj.kdChartObj.chartData.data.getLinks();
        var transition = this.manViewObj.group.transition().duration(500);
        var linkGroup = this.gLink.selectAll("path")
            .data(this.links, function (d) { return d["target"]["id"]; });
        var linkEnter = linkGroup.enter().append("path");
        linkGroup.exit().remove()
            .attr("d", this.endElbow(currNode))
            .attr("stroke-opacity", 0);
        if (rePaintPath) {
            this.paintPath(linkEnter, currNode);
        }
        this.linkupdate = linkGroup.merge(linkEnter).transition(transition)
            .attr("stroke-opacity", 1)
            .attr("d", function (d) { return _this.elbow(d); })
            .attr("stroke", this.pathTheme.stroke);
    };
    ChartPathObj.prototype.resetPaint = function (currNode, rePaintPath) {
        if (rePaintPath === void 0) { rePaintPath = true; }
        //rePaintPath 是否重新绘制连线（有新的卡片的时候，如：展开）
        this.initPaint(currNode, rePaintPath);
    };
    ChartPathObj.prototype.partPathPaint = function () {
        var _this = this;
        this.linkupdate._groups[0].map(function (path) {
            var flag = !_this.manViewObj.isInPaintView(path.__data__.target) && !_this.manViewObj.isInPaintView(path.__data__.source);
            path.setAttribute("d", _this.elbow(flag ? "" : path.__data__));
        });
    };
    ChartPathObj.prototype.resetPaint2moveNode = function (moveNodesId, dragStatus) {
        var _this = this;
        if (this.upSt) {
            clearTimeout(this.upSt);
        }
        this.upStep++;
        if (this.upStep >= PathUpStep) {
            this.upStep = 0;
            this.executeResetPaint2moveNode(moveNodesId, dragStatus);
        }
        else {
            this.upSt = setTimeout(function () {
                _this.executeResetPaint2moveNode(moveNodesId, dragStatus);
                clearTimeout(_this.upSt);
            }, 60);
        }
    };
    ChartPathObj.prototype.executeResetPaint2moveNode = function (moveNodesId, dragStatus) {
        var _this = this;
        this.linkupdate._groups[0].map(function (path) {
            var data = path.__data__;
            if (moveNodesId.indexOf(data.target.id) > -1) {
                path.setAttribute("d", _this.elbow(data));
                if (dragStatus == 2) {
                    path.setAttribute("stroke", _this.pathTheme.stroke);
                }
                else {
                    path.setAttribute("stroke", _this.pathTheme.activeStroke);
                }
            }
            if (moveNodesId.indexOf(data.source.id) > -1) {
                path.setAttribute("d", _this.elbow(data));
                // if (dragStatus == 1) {
                //     path.setAttribute("d", this.moveElbow(data))
                // } else {
                //     path.setAttribute("d", this.elbow(data))
                // }
                if (dragStatus == 2) {
                    path.setAttribute("stroke", _this.pathTheme.stroke);
                }
                else {
                    path.setAttribute("stroke", _this.pathTheme.activeStroke);
                }
            }
        });
    };
    ChartPathObj.prototype.paintPath = function (linkEnter, currNode) {
        linkEnter
            .attr("cursor", "move")
            .attr("stroke", this.pathTheme.stroke)
            .attr("stroke-opacity", 0.1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto")
            .attr("d", this.initElbow(currNode));
    };
    ChartPathObj.prototype.initElbow = function (currNode, scale) {
        if (scale === void 0) { scale = 1; }
        return getInitElbow(currNode, scale);
    };
    ChartPathObj.prototype.elbow = function (path, scale, ignore) {
        if (scale === void 0) { scale = 1; }
        if (ignore === void 0) { ignore = false; }
        if (!ignore && (!this.manViewObj.isInPaintView(path.target) && !this.manViewObj.isInPaintView(path.source)))
            return "";
        return getElbow(path, scale, this.manViewObj.kdChartObj.viewConfig.direction, this.manViewObj.kdChartObj.pathConfig.elbowRatio, this.manViewObj.kdChartObj.getPathScheme, this.manViewObj.kdChartObj.cardConfig.baseCardSize);
    };
    ChartPathObj.prototype.endElbow = function (currNode, scale) {
        if (scale === void 0) { scale = 1; }
        return getEndElbow(currNode, scale);
    };
    ChartPathObj.prototype.moveElbow = function (path, scale) {
        if (scale === void 0) { scale = 1; }
        if (!this.manViewObj.isInPaintView(path.target) && !this.manViewObj.isInPaintView(path.source))
            return "";
        return moveElbow(path, scale, this.manViewObj.kdChartObj.viewConfig.direction);
    };
    return ChartPathObj;
}());

var SortCard = /** @class */ (function () {
    function SortCard(manViewObj) {
        this.manViewObj = manViewObj;
        this.initSortCard();
    }
    SortCard.prototype.initSortCard = function () {
        this.sortPreRect = this.manViewObj.group
            .append("svg:g")
            .attr("style", "display:none")
            .attr("transform", "translate(0,0)");
        this.sortPreRectInner = this.sortPreRect.append("svg:rect")
            .attr("width", this.manViewObj.kdChartObj.cardConfig.baseCardSize.xSpace - 8)
            .attr("height", this.manViewObj.kdChartObj.cardConfig.baseCardSize.height)
            .attr("rx", 2)
            .attr("stroke", "#1890ff")
            .attr("stroke-dasharray", "2 2 2")
            .attr("stroke-linecap", "round")
            .attr("stroke-opacity", 1)
            .attr("fill", "#e6f7ff")
            .attr("fill-opacity", 1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto");
    };
    SortCard.prototype.showSortCard = function (node, maxareaNode) {
        var _this = this;
        var i = -1; //挪动的节点
        var j = -1; //挪动节点的目标节点
        node.parent.children.map(function (citem, index) {
            if (citem.id === node.id) {
                i = index;
            }
            if (citem.id === maxareaNode.id) {
                j = index;
                _this.sortTargetNode = citem;
            }
        });
        if (i > -1 && j > -1) {
            var targeCardSize = maxareaNode.cardSize;
            if (i > j) { //出现在j前面
                this.transSortCard({
                    x: this.sortTargetNode.x + 4 - targeCardSize.xSpace - targeCardSize.width / 2,
                    y: this.sortTargetNode.y - targeCardSize.height / 2,
                    h: targeCardSize.height
                });
            }
            else {
                this.transSortCard({
                    x: this.sortTargetNode.x + 4 + targeCardSize.width - targeCardSize.width / 2,
                    y: this.sortTargetNode.y - targeCardSize.height / 2,
                    h: targeCardSize.height
                });
            }
        }
    };
    SortCard.prototype.transSortCard = function (loc) {
        if (this.sortPreRect) {
            this.sortPreRect
                .attr("transform", "translate(" + loc.x + "," + loc.y + ")")
                .attr("style", "");
            this.sortPreRectInner
                .attr("height", loc.h);
        }
    };
    SortCard.prototype.delSortCard = function () {
        if (this.sortPreRect) {
            this.sortPreRect.attr("style", "display:none");
            this.sortTargetNode = null;
        }
    };
    return SortCard;
}());

var ChartCardShadow = /** @class */ (function () {
    function ChartCardShadow(manViewObj) {
        this.manViewObj = manViewObj;
        this.initCardShadow();
    }
    ChartCardShadow.prototype.initCardShadow = function () {
        this.cardShadow = d3.create("svg:g")
            .attr("transform", "translate(0,0)");
        this.inRect = this.cardShadow.append("svg:rect")
            .attr("width", this.manViewObj.kdChartObj.cardConfig.baseCardSize.width)
            .attr("height", this.manViewObj.kdChartObj.cardConfig.baseCardSize.height)
            .attr("rx", 2)
            .attr("stroke", "#1890ff")
            .attr("stroke-dasharray", "3 3 3")
            .attr("stroke-linecap", "round")
            .attr("stroke-opacity", 1)
            .attr("fill", "#eeeeee")
            .attr("fill-opacity", 1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto");
    };
    ChartCardShadow.prototype.showCardShadow = function (node, currParent) {
        if (this.cardShadow) {
            var loc = {
                x: node.x - this.manViewObj.kdChartObj.cardConfig.baseCardSize.width / 2,
                y: node.y - this.manViewObj.kdChartObj.cardConfig.baseCardSize.height / 2
            };
            this.cardShadow
                .attr("transform", "translate(" + loc.x + "," + loc.y + ")");
            this.inRect
                .attr("width", node.cardSize.width)
                .attr("height", node.cardSize.height);
            currParent.appendChild(this.cardShadow.node());
        }
    };
    ChartCardShadow.prototype.delCardShadow = function () {
        if (this.cardShadow) {
            this.cardShadow.remove();
        }
    };
    return ChartCardShadow;
}());

var ChartCardMenu = /** @class */ (function () {
    function ChartCardMenu(manViewObj) {
        this.manViewObj = manViewObj;
        this.currOpNode = null;
        this.initCardMenu();
    }
    ChartCardMenu.prototype.initCardMenu = function () {
        var _this = this;
        this.cardMenu = d3.create("svg:g")
            .attr("transform", "translate(0,0)");
        this.manViewObj.menuModel.map(function (menuModel) {
            var _a, _b, _c, _d;
            switch (menuModel.tag) {
                case "text":
                case "text":
                    _this.cardMenu.append("svg:text")
                        .text(menuModel.text)
                        .attr("class", "icon manhead-icon " + menuModel.class)
                        .attr("fill", menuModel.color)
                        .attr("text-anchor", "start")
                        .attr("font-size", menuModel.fontSize)
                        .attr("font-weight", menuModel.fontWeight)
                        .attr("x", menuModel.x)
                        .attr("y", menuModel.y + menuModel.fontSize)
                        .attr("font-family", SVGFontFamily)
                        .attr("word-spacing", 0)
                        .attr("letter-spacing", 0)
                        .on("click", function () {
                            menuModel.click && menuModel.click(_this.manViewObj.kdChartObj);
                        });
                    break;
                case "rect":
                    _this.cardMenu.append("svg:rect")
                        .attr("x", menuModel.x)
                        .attr("y", menuModel.y)
                        .attr("width", menuModel.w)
                        .attr("height", menuModel.h)
                        .attr("class", (_a = menuModel.class) !== null && _a !== void 0 ? _a : "")
                        .attr("rx", (_b = menuModel.rx) !== null && _b !== void 0 ? _b : 2)
                        .attr("fill", (_c = menuModel.fill) !== null && _c !== void 0 ? _c : "#fff")
                        .attr("stroke", (_d = menuModel.stroke) !== null && _d !== void 0 ? _d : "#ccc")
                        .attr("shape-rendering", "crispEdges");
                    break;
            }
        });
    };
    ChartCardMenu.prototype.showCardMenu = function (node) {
        var _this = this;
        this.currOpNode = node;
        if (this.cardMenu) {
            this.resetCardMenu(node);
            this.manViewObj.group.append(function () { return _this.cardMenu.node(); });
        }
    };
    ChartCardMenu.prototype.resetCardMenu = function (node) {
        var _this = this;
        if (this.cardMenu) {
            searchNodeByID(this.manViewObj.kdChartObj.chartData.data, node.id, function (item) {
                var loc = {
                    x: item.x - item.cardSize.width / 2,
                    y: item.y + item.cardSize.height / 2
                };
                _this.cardMenu.attr("transform", "translate(" + loc.x + "," + loc.y + ")");
            });
        }
    };
    ChartCardMenu.prototype.delCardMenu = function () {
        this.currOpNode = null;
        if (this.cardMenu) {
            this.cardMenu.remove();
        }
    };
    return ChartCardMenu;
}());

var TipsCard = /** @class */ (function () {
    function TipsCard(manViewObj) {
        this.manViewObj = manViewObj;
        this.initTipsGroup();
    }
    TipsCard.prototype.initTipsGroup = function () {
        this.showFlag = false;
        this.tipsGroup = this.manViewObj.group
            .append("svg:g")
            .attr("style", "display:none")
            .attr("transform", "translate(0,0)");
    };
    TipsCard.prototype.showTipsGroup = function (loc, doms) {
        if (this.showFlag)
            return;
        this.showFlag = true;
        this.tipsGroup
            .attr("style", "")
            .attr("transform", "translate(" + loc.x + "," + loc.y + ")");
        for (var i = 0; i < doms.length; i++) {
            this.tipsGroup._groups[0][0].appendChild(doms[i].node());
        }
    };
    TipsCard.prototype.hideTipsGroup = function () {
        this.showFlag = false;
        this.tipsGroup
            .attr("style", "display:none")
            .attr("transform", "translate(0,0)");
        this.tipsGroup._groups[0][0].innerHTML = "";
    };
    return TipsCard;
}());

var MarkRect = /** @class */ (function () {
    function MarkRect(markRectSys, markParams) {
        this.markRectSys = markRectSys;
        this.markConfig = {
            fontSize: 12,
            iconSize: 12
        };
        this.markParams = markParams;
        this.text = "注";
        this.initMark();
    }
    MarkRect.prototype.initMark = function () {
        var _this = this;
        var markParams = this.markParams;
        this.markGroup = this.markRectSys.manViewObj.group.append("svg:g")
            .attr("id", markParams.markId);
        this.paintLine("M" + markParams.minx + "," + markParams.miny + " H" + markParams.maxx);
        this.paintLine("M" + markParams.maxx + "," + markParams.miny + " V" + markParams.maxy);
        this.paintLine("M" + markParams.maxx + "," + markParams.maxy + " H" + markParams.minx);
        this.paintLine("M" + markParams.minx + "," + markParams.maxy + " V" + markParams.miny);
        this.markGroup.appendChild("svg:text")
            .html('&#xe7c3;')
            .attr("class", "iconfont markIcon")
            .attr("fill", "#060")
            .attr("x", markParams.maxx - this.markConfig.iconSize)
            .attr("y", markParams.miny + this.markConfig.iconSize / 3)
            .style("font-size", this.markConfig.iconSize)
            .on("click", function (e) {
                _this.markRectSys.delMarkRectItem(markParams.markId);
            });
        var loc = { x: markParams.minx, y: markParams.miny };
        this.markGroup.appendChild("svg:text")
            .html('&#xe7e1;')
            .attr("class", "iconfont markIcon")
            .attr("fill", "#060")
            .attr("x", markParams.maxx - this.markConfig.iconSize * 2.2)
            .attr("y", markParams.miny + this.markConfig.iconSize / 3)
            .style("font-size", this.markConfig.iconSize)
            .on("click", function () {
                _this.markRectSys.manViewObj.editTextByDom.singleInput(loc, _this.text, function (val) {
                    _this.text = val;
                    _this.textDom.text(_this.text);
                });
            });
        this.textDom = this.markGroup.appendChild("svg:text")
            .text(this.text)
            .attr("x", markParams.minx)
            .attr("y", markParams.miny + this.markConfig.fontSize / 2)
            .attr("font-size", this.markConfig.fontSize)
            .attr("fill", "#f00")
            .attr("fill-opacity", 0.7);
    };
    MarkRect.prototype.paintLine = function (d) {
        this.markGroup.appendChild("svg:path")
            .attr("class", "infoLine")
            .attr("d", d)
            .attr("fill-opacity", 0)
            .attr("stroke-width", 1)
            .attr("stroke", "#94c074")
            .attr("stroke-dasharray", "6 6 6 ");
    };
    return MarkRect;
}());

var MarkRectSys = /** @class */ (function () {
    function MarkRectSys(manViewObj) {
        this.manViewObj = manViewObj;
        this.markRectList = [];
        d3.selectAll(".markIcon").style("display", "none");
    }
    MarkRectSys.prototype.initMarkRect = function (markRectList) {
        this.markRectList = markRectList;
    };
    MarkRectSys.prototype.paintMarkRect = function (selectedCardList) {
        var markParams = this.computedParams(selectedCardList);
        var markRectItem = new MarkRect(this, markParams);
        // this.markRectList.push(markRectItem)
        return markRectItem;
    };
    MarkRectSys.prototype.saveMarkChange = function (list) {
        this.markRectList = __spreadArray(__spreadArray([], this.markRectList, true), list);
    };
    MarkRectSys.prototype.delMarkRectItem = function (markId) {
        var delIndex = -1;
        for (var i = 0; i < this.manViewObj.markRecord.length; i++) {
            var markRectItem = this.manViewObj.markRecord[i];
            if (markRectItem.markParams.markId === markId) {
                markRectItem.markGroup.remove();
                delIndex = i;
                break;
            }
        }
        this.manViewObj.markRecord.splice(delIndex, 1);
    };
    MarkRectSys.prototype.computedParams = function (selectedCardList) {
        var minx = Infinity;
        var miny = Infinity;
        var maxx = -Infinity;
        var maxy = -Infinity;
        var offset = 10;
        var markId = "mark";
        selectedCardList.map(function (node) {
            markId += ("_" + node.id);
            minx = Math.min(minx, node.x - node.cardSize.width / 2 - offset);
            miny = Math.min(miny, node.y - node.cardSize.height / 2 - offset);
            maxx = Math.max(maxx, node.x + node.cardSize.width / 2 + offset);
            maxy = Math.max(maxy, node.y + node.cardSize.height / 2 + offset);
        });
        return {
            minx: minx,
            miny: miny,
            maxx: maxx,
            maxy: maxy,
            width: maxx - minx,
            height: maxy - miny,
            markId: markId
        };
    };
    return MarkRectSys;
}());

var EditTextByDom = /** @class */ (function () {
    function EditTextByDom(manViewObj) {
        this.manViewObj = manViewObj;
    }
    EditTextByDom.prototype.singleInput = function (loc, val, cb) {
        var offsetx = (this.manViewObj.svgSize.width - this.manViewObj.kdChartObj.svgWrapperSize.width + this.manViewObj.svgSize.width) / 2;
        var inp = document.createElement("input");
        inp.value = val;
        inp.className = "edit_inp";
        inp.style.left = (loc.x + offsetx - 24) + "px";
        inp.style.top = loc.y + "px";
        inp.onkeyup = function (e) {
            if (e.code === "Enter") {
                cb(inp.value);
                inp.remove();
            }
        };
        document.getElementById(this.manViewObj.svgwrapperID).appendChild(inp);
    };
    EditTextByDom.prototype.formInput = function () {
    };
    EditTextByDom.prototype.textAreaInput = function () {
    };
    return EditTextByDom;
}());

var MainViewobj = /** @class */ (function () {
    function MainViewobj(kdChartObj, mvParams) {
        this.cardModel = mvParams.cardModel;
        this.menuModel = mvParams.menuModel;
        this.kdChartObj = kdChartObj;
        this.initParams(mvParams);
        this.initStatus();
        this.initWrapper();
    }
    MainViewobj.prototype.resetData = function () {
        this.initStatus();
        this.initWrapper();
    };
    MainViewobj.prototype.resetWrapperSize = function () {
        this.initStatus();
        this.initWrapper();
    };
    MainViewobj.prototype.initParams = function (mvParams) {
        this.svgTheme = {
            background: SVG_THEME.background
        };
        this.config = {
            toogleBtn: false,
            textTips: true,
            fullTips: false
        };
        this.iconConfig = {
            fontSize: 16,
            drillup: {
                unicode: ICON_UNICODE.drillup,
                color: ICON_COLOR.drillup
            },
            drillDown: {
                unicode: ICON_UNICODE.drillDown,
                color: ICON_COLOR.drillDown
            },
            toogleMinus: {
                unicode: ICON_UNICODE.toogleMinus,
                color: ICON_COLOR.toogleMinus
            },
            tooglePlus: {
                unicode: ICON_UNICODE.tooglePlus,
                color: ICON_COLOR.tooglePlus
            },
            class: ICONFONT_CLASS
        };
        if (mvParams) {
            this.config.toogleBtn = mvParams.toogleBtn || false;
            this.config.textTips = mvParams.textTips || false;
            this.config.fullTips = mvParams.fullTips || false;
            this.iconConfig = mvParams.iconConfig;
        }
    };
    MainViewobj.prototype.initStatus = function () {
        this.svgSize = {
            width: 0,
            height: 0,
            rx: 0,
            ry: 0
        };
        this.relativeMaxLoc = {
            x: -Infinity,
            y: -Infinity
        };
        this.isRelativeMaxChange = true;
        this.paintInfoTime = 0;
        this.currMovementX = 0;
        this.currMovementY = 0;
        this.sortRecord = [];
        this.markRecord = [];
        this.loadRecord = [];
    };
    MainViewobj.prototype.initWrapper = function () {
        this.initDom();
        this.initChart();
    };
    MainViewobj.prototype.initDom = function () {
        // this.kdChartObj.chartDom.innerHTML = ""
        this.svgwrapperID = this.kdChartObj.chartDom.getAttribute("id") + "" + "svg_wrapper";
        if (d3.select("#" + this.svgwrapperID))
            d3.select("#" + this.svgwrapperID).remove();
        this.svgWrapper = d3.create("div")
            .attr("class", "svg_wrapper")
            .attr("id", this.svgwrapperID)
            .style("width", this.kdChartObj.svgWrapperSize.width + "px")
            .style("height", (this.kdChartObj.svgWrapperSize.height) + "px")
            .style("box-sizing", "border-box")
            .style("position", "absolute")
            .style("overflow", "hidden")
            .style("left", "50%")
            .style("top", "0")
            .style("transform", "translateX(-50%)");
        this.svgWrapper.html("<div class='null_data'><div class='img' ></div><p>您没有组织权限,暂时无法查看行政组织结构图</p><p>如需获取组织权限，请联系管理员</p></div>");
        this.kdChartObj.chartDom.appendChild(this.svgWrapper.node());
    };
    MainViewobj.prototype.initChart = function () {
        var _this = this;
        if (!this.kdChartObj.chartData.data)
            return;
        this.svgWrapper.html(null);
        this.svgWrapper.append(function () { return _this.initSvg(); });
    };
    MainViewobj.prototype.initSvg = function () {
        this.svg = d3.create("svg")
            .style("background", this.svgTheme.background)
            .style("user-select", "none");
        this.group = this.svg.append("g");
        this.bindSvgEvent();
        this.readyPaint();
        //排序提示框
        this.paintSortRect();
        //文字超长提示框
        this.paintTipsGroup();
        //多卡片范围标记框
        this.initMarkRect();
        //编辑内容的文字
        this.initEditText();
        //拖动卡片残影
        this.initMoveShadow();
        //卡片菜单
        // this.initCardMenu()
        return this.svg.node();
    };
    MainViewobj.prototype.initMoveShadow = function () {
        this.cardShadow = new ChartCardShadow(this);
    };
    MainViewobj.prototype.initCardMenu = function () {
        this.cardMenu = new ChartCardMenu(this);
    };
    MainViewobj.prototype.paintSortRect = function () {
        this.sortCard = new SortCard(this);
    };
    MainViewobj.prototype.paintTipsGroup = function () {
        this.tipsCard = new TipsCard(this);
    };
    MainViewobj.prototype.initMarkRect = function () {
        this.markRectSys = new MarkRectSys(this);
    };
    MainViewobj.prototype.initEditText = function () {
        this.editTextByDom = new EditTextByDom(this);
    };
    //结构图是否被拖拽=>结构图重绘后的初始位置
    MainViewobj.prototype.brforePaint = function (moveNodeOffset) {
        if (moveNodeOffset === void 0) { moveNodeOffset = { rx: 0, ry: 0 }; }
        this.extremeNodeLoc();
        if (this.isRelativeMaxChange) {
            this.getSvgGroup2Loc(this.kdChartObj.chartData.data, moveNodeOffset);
            this.resetSvgLoc();
            this.resetGroupLoc();
        }
    };
    MainViewobj.prototype.readyPaint = function () {
        this.brforePaint();
        this.paintPath(this.kdChartObj.chartData.data);
        this.paintCard(this.kdChartObj.chartData.data);
    };
    MainViewobj.prototype.resetPaint = function (currNode, repaint) {
        if (repaint === void 0) { repaint = true; }
        //重新绘制前，检查绘图最大宽度
        this.brforePaint({
            rx: this.groupLoc.x - this.intialGroupLoc.x,
            ry: this.groupLoc.y - this.intialGroupLoc.y
        });
        this.kdChartObj.preView && this.kdChartObj.preView.readyPaint();
        this.chartPath.resetPaint(currNode, repaint);
        this.chartCard.resetPaint(currNode, repaint);
    };
    MainViewobj.prototype.paintMoveNode = function (currNode, repaint) {
        if (repaint === void 0) { repaint = true; }
        this.chartCard.resetPaint(currNode, repaint);
    };
    MainViewobj.prototype.resetSvgLoc = function () {
        this.svg.style("width", this.svgSize.width + "px")
            .style("height", this.svgSize.height + "px")
            .style("transform", "translate(" + this.svgSize.rx + "px," + this.svgSize.ry + "px)");
    };
    MainViewobj.prototype.resetGroupLoc = function (loc) {
        if (loc === void 0) {
            loc = {
                rx: 0,
                ry: 0,
                k: this.groupLoc.k
            };
        }
        this.groupLoc.x += loc.rx;
        this.groupLoc.y += loc.ry;
        this.groupLoc.k = loc.k || this.groupLoc.k;
        this.group.attr("transform", "translate(" + this.groupLoc.x + "," + this.groupLoc.y + ") scale(" + this.groupLoc.k + ")");
        //缩放、移动操作需要更新加载的节点（卡片节点按需加载）
        this.lazyPaintRest(loc.rx, loc.ry);
    };
    //判断svg在X轴或者Y轴移动的像素，是否达到了更新视图的值，需累计移动ViewOffset（1000）像素
    MainViewobj.prototype.lazyPaintRest = function (rx, ry) {
        this.currMovementX += rx;
        this.currMovementY += ry;
        if (Math.abs(this.currMovementX) >= ViewOffset * this.groupLoc.k || Math.abs(this.currMovementY) >= ViewOffset * this.groupLoc.k) {
            this.currMovementX = 0;
            this.currMovementY = 0;
            this.prePaintInfo();
        }
    };
    //绘制svg里面的内容（卡片、连线）
    MainViewobj.prototype.prePaintInfo = function () {
        var _this = this;
        if (this.paintST) {
            clearTimeout(this.paintST);
        }
        if (new Date().getTime() - this.paintInfoTime > 500) {
            this.paintInfoTime = new Date().getTime();
            this.resetCardAndPath();
        }
        else {
            this.paintST = setTimeout(function () {
                _this.resetCardAndPath();
            }, 0);
        }
    };
    //绘制卡片
    MainViewobj.prototype.paintCard = function (currNode) {
        this.chartCard = new ChartCardObj(this);
        this.chartCard.initPaint(currNode);
    };
    //动态更新卡片、连线
    MainViewobj.prototype.resetCardAndPath = function () {
        this.chartCard.paintInfo();
        this.chartPath.partPathPaint();
    };
    //绘制连线
    MainViewobj.prototype.paintPath = function (currNode) {
        this.chartPath = new ChartPathObj(this);
        this.chartPath.initPaint(currNode);
    };
    //根据卡片坐标点，计算坐标极值
    //isRelativeMaxChange 最大宽度是否改变
    MainViewobj.prototype.extremeNodeLoc = function () {
        var _this = this;
        this.maxLoc = {
            x: -Infinity,
            y: -Infinity
        };
        this.minLoc = {
            x: Infinity,
            y: Infinity
        };
        var relativeMaxLocX = -Infinity;
        var relativeMaxLocY = -Infinity;
        this.kdChartObj.chartData.data.getNodes().forEach(function (node) {
            _this.minLoc.x = Math.min(node.x, _this.minLoc.x);
            _this.minLoc.y = Math.min(node.y, _this.minLoc.y);
            _this.maxLoc.x = Math.max(node.x, _this.maxLoc.x);
            _this.maxLoc.y = Math.max(node.y, _this.maxLoc.y);
        });
        relativeMaxLocX = Math.max(this.maxLoc.x, Math.abs(this.minLoc.x));
        relativeMaxLocY = Math.max(this.maxLoc.y, Math.abs(this.minLoc.y));
        this.relativeMaxLoc.x = relativeMaxLocX;
        this.relativeMaxLoc.y = relativeMaxLocY;
        var newSvgSizeWidth = Math.max(this.relativeMaxLoc.x * 2 + this.kdChartObj.cardConfig.baseCardSize.width * 2, this.kdChartObj.svgWrapperSize.width);
        this.isRelativeMaxChange = newSvgSizeWidth !== this.svgSize.width;
    };
    //svg'size group'location
    //moveNodeOffsetX：折叠等操作前，group已经移动的距离
    MainViewobj.prototype.getSvgGroup2Loc = function (chartData, moveNodeOffset) {
        if (moveNodeOffset === void 0) { moveNodeOffset = { rx: 0, ry: 0 }; }
        //计算svg所需的宽度\高度
        var width = Math.max(this.relativeMaxLoc.x * 2 + this.kdChartObj.cardConfig.baseCardSize.width * 2, this.kdChartObj.svgWrapperSize.width);
        var height = Math.max(this.relativeMaxLoc.y + 150, this.kdChartObj.svgWrapperSize.height);
        //svg的宽高和位置
        this.svgSize = {
            width: width,
            height: height,
            rx: (this.kdChartObj.svgWrapperSize.width - width) / 2,
            ry: 0
        };
        //计算group缩放倍数
        var k = 1;
        if (this.groupLoc && this.groupLoc.k) {
            k = this.groupLoc.k;
        }
        switch (this.kdChartObj.viewConfig.direction) {
            case 1:
                //group偏移坐标和缩放倍数
                // - chartData.x 水平始终居中
                this.groupLoc = {
                    x: this.svgSize.width / 2 - chartData.x + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                //保留groupLoc初始数据
                // - chartData.x 水平始终居中
                this.intialGroupLoc = {
                    x: this.svgSize.width / 2 - chartData.x,
                    y: 0,
                    k: k,
                };
                break;
            case 2:
                this.groupLoc = {
                    x: this.svgSize.width / 2 + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                this.intialGroupLoc = {
                    x: this.svgSize.width / 2,
                    y: 0,
                    k: k,
                };
                break;
            case 3:
                this.groupLoc = {
                    x: this.svgSize.width / 2 - chartData.x + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                this.intialGroupLoc = {
                    x: this.svgSize.width / 2 - chartData.x,
                    y: 0,
                    k: k,
                };
                break;
            case 4:
                this.groupLoc = {
                    x: this.svgSize.width / 2 + moveNodeOffset.rx,
                    y: moveNodeOffset.ry,
                    k: k,
                };
                this.intialGroupLoc = {
                    x: this.svgSize.width / 2,
                    y: 0,
                    k: k,
                };
                break;
        }
    };
    MainViewobj.prototype.bindSvgEvent = function () {
        var _this = this;
        this.svg
            .call(d3.zoom()
                .on("zoom", function (e) {
                    switch (e.sourceEvent.type) {
                        case "wheel":
                            var step = 0.2;
                            var k = _this.groupLoc.k + (e.sourceEvent.wheelDelta > 0 ? 1 : -1) * step;
                            k = k >= 2 ? 2 : k;
                            k = k <= 0.5 ? 0.5 : k;
                            _this.kdChartObj.preView && _this.kdChartObj.preView.resetGroupLoc({
                                rx: 0,
                                ry: 0,
                                k: k
                            });
                            _this.resetGroupLoc({
                                rx: 0,
                                ry: 0,
                                k: k
                            });
                            break;
                        case "mousemove":
                            var rx = e.sourceEvent.movementX / window.devicePixelRatio;
                            var ry = e.sourceEvent.movementY / window.devicePixelRatio;
                            _this.kdChartObj.preView && _this.kdChartObj.preView.resetGroupLoc({
                                rx: rx,
                                ry: ry,
                                k: _this.groupLoc.k
                            });
                            _this.resetGroupLoc({
                                rx: rx,
                                ry: ry,
                                k: _this.groupLoc.k
                            });
                            break;
                    }
                }))
            .on("click.zoom", function (e) {
                if (e.target.nodeName === "svg") {
                    if (_this.kdChartObj.editStatus) {
                        _this.clearSelectCard();
                    }
                }
            });
    };
    MainViewobj.prototype.isInPaintView = function (node) {
        if (!node)
            return false;
        var svgWrapperSize = this.kdChartObj.svgWrapperSize;
        var groupPot = {
            x: this.svgSize.width / 2,
            y: 0
        };
        var isin = true;
        var minX = -svgWrapperSize.width * 0.5 - ViewOffset;
        var maxX = svgWrapperSize.width * 0.5 + ViewOffset;
        var minY = -svgWrapperSize.height * 0 - ViewOffset;
        var maxY = svgWrapperSize.height * 1 + ViewOffset;
        // (this.groupLoc.x - groupPot.x)  group横向偏移距离
        // flagX 该卡片横向偏移后的坐标
        var flagX = node.x * this.groupLoc.k + (this.groupLoc.x - groupPot.x);
        // (this.groupLoc.y - groupPot.y)  group纵向偏移距离
        // flagY该卡片纵向偏移后的坐标
        var flagY = node.y * this.groupLoc.k + (this.groupLoc.y - groupPot.y);
        // 偏移后的相对坐标，在可加载区域内，则渲染
        isin = flagX > minX && flagX < maxX && flagY > minY && flagY < maxY;
        return isin;
    };
    MainViewobj.prototype.paintMarkRect = function () {
        if (this.chartCard.selectedCard.length === 0)
            return;
        var markRectItem = this.markRectSys.paintMarkRect(this.chartCard.selectedCard);
        this.markRecord.push(markRectItem);
        this.clearSelectCard();
    };
    MainViewobj.prototype.clearSelectCard = function () {
        d3.selectAll(".ghover").classed("ghover", false);
        this.chartCard.selectedCard = [];
    };
    MainViewobj.prototype.saveEdit = function () {
        this.saveSort();
        this.saveMark();
        this.saveLoad();
    };
    MainViewobj.prototype.saveSort = function () {
        this.sortRecord = [];
    };
    MainViewobj.prototype.saveMark = function () {
        this.markRectSys.saveMarkChange(this.markRecord);
        this.markRecord = [];
    };
    MainViewobj.prototype.saveLoad = function () {
        this.loadRecord = [];
    };
    MainViewobj.prototype.cancelEdit = function () {
        this.cancelSort();
        this.cancelMark();
        this.cancelLoad();
        this.kdChartObj.chartData.resetChartData();
        this.resetPaint(this.kdChartObj.chartData.data);
    };
    MainViewobj.prototype.cancelSort = function () {
        var _this = this;
        this.sortRecord.map(function (item) {
            _this.kdChartObj.treeData.exchangeItem(item.pNode.id, item.j, item.i);
            _this.kdChartObj.chartData.exchangeNode(item.pNode, item.j, item.i);
        });
        this.sortRecord = [];
    };
    MainViewobj.prototype.cancelMark = function () {
        this.markRecord.map(function (item) {
            item.markGroup.remove();
        });
        this.markRecord = [];
    };
    MainViewobj.prototype.cancelLoad = function () {
        this.loadRecord.map(function (node) {
            node.isLeaf = !node.isLeaf;
            node.data.isLeaf = node.isLeaf;
        });
        this.loadRecord = [];
    };
    return MainViewobj;
}());

var PreViewObj = /** @class */ (function () {
    function PreViewObj(kdChartObj, preParams) {
        if (!kdChartObj.chartData.data) {
            d3.selectAll(".preview_wrapper").remove();
            return;
        }
        this.kdChartObj = kdChartObj;
        //缩略图svg
        this.previewSvgSize = preParams.previewSvgSize;
        this.initParams();
        this.initDom();
        this.initChart();
    }
    PreViewObj.prototype.resetData = function () {
        this.initChart();
    };
    PreViewObj.prototype.resetWrapperSize = function () {
        this.initParams();
        this.initChart();
    };
    PreViewObj.prototype.initParams = function () {
        //缩略图的缩小比例
        this.previewScale = Math.min(this.previewSvgSize.width / this.kdChartObj.mainView.svgSize.width, this.previewSvgSize.height / this.kdChartObj.mainView.svgSize.height);
        //区域框：主图显示的部分
        // this.preWinRectSize = {
        //     width: this.kdChartObj.mainView.svgWrapper["_groups"][0][0].offsetWidth * this.previewScale,
        //     height: this.kdChartObj.mainView.svgWrapper["_groups"][0][0].offsetHeight * this.previewScale
        // }
        this.preWinRectSize = {
            width: this.kdChartObj.svgWrapperSize.width * this.previewScale,
            height: this.kdChartObj.svgWrapperSize.height * this.previewScale
        };
        //区域框坐标
        this.previewWinLoc = {
            x: this.previewSvgSize.width / 2,
            y: 0,
            k: 1
        };
        //区域框坐标
        this.previewWinRectLoc = {
            x: -this.preWinRectSize.width / 2,
            y: 0
        };
        this.groupLoc = {
            x: this.previewSvgSize.width / 2,
            y: 0,
            k: 1,
        };
        var offsetW = (this.previewSvgSize.width - this.preWinRectSize.width) / 2;
        this.preWinRectRange = {
            maxX: this.previewWinRectLoc.x + offsetW,
            minX: this.previewWinRectLoc.x - offsetW,
            maxY: this.previewSvgSize.height - this.preWinRectSize.height,
            minY: 0,
        };
    };
    PreViewObj.prototype.initDom = function () {
        d3.selectAll(".preview_wrapper").remove();
        this.previewWrapper = d3.create("div")
            .attr("class", "preview_wrapper")
            .style("width", this.previewSvgSize.width + "px")
            .style("height", this.previewSvgSize.height + "px")
            .style("box-sizing", "border-box")
            .style("box-shadow", "0 0 1px 0 #000")
            .style("position", "absolute")
            .style("top", "4px")
            .style("right", "16px")
            .style("overflow", "hidden")
            .style("z-index", "1");
        this.kdChartObj.chartDom.appendChild(this.previewWrapper.node());
    };
    PreViewObj.prototype.initChart = function () {
        var _this = this;
        this.previewWrapper.html(null);
        this.previewWrapper.append(function () { return _this.initSvg(); });
    };
    PreViewObj.prototype.initSvg = function () {
        this.svg = d3.create("svg")
            .style("width", this.previewSvgSize.width + "px")
            .style("height", this.previewSvgSize.height + "px")
            .style("background", "#fff")
            .style("user-select", "none");
        this.group = this.svg.append("g")
            .attr("transform", "translate(" +
                this.groupLoc.x + "," +
                this.groupLoc.y + ") scale(" +
                this.groupLoc.k + ")");
        this.gLink = this.group.append("g")
            .attr("fill", "none");
        this.gNode = this.group.append("g")
            .attr("cursor", "pointer")
            .attr("pointer-events", "visible");
        this.readyPaint();
        this.paintWin();
        return this.svg.node();
    };
    PreViewObj.prototype.readyPaint = function () {
        this.paintCard(this.kdChartObj.chartData.data);
        this.paintPath(this.kdChartObj.chartData.data);
    };
    PreViewObj.prototype.paintPath = function (currNode) {
        var _this = this;
        this.links = this.kdChartObj.chartData.data.getLinks();
        var transition = this.group.transition().duration(500);
        var linkGroup = this.gLink.selectAll("path")
            .data(this.links, function (d) { return d["target"]["id"]; });
        var linkEnter = linkGroup.enter().append("path")
            .attr("stroke", "#d9d9d9")
            .attr("stroke-opacity", 1)
            .attr("stroke-width", 1)
            .attr("shape-rendering", "auto");
        this.linkupdate = linkGroup.merge(linkEnter)
            .transition(transition)
            .attr("stroke-opacity", 1)
            .attr("stroke-width", 1)
            .attr("d", function (d) { return _this.elbow(d, _this.previewScale); });
        linkGroup.exit().transition(transition).remove()
            .attr("stroke-opacity", 0.1);
    };
    PreViewObj.prototype.paintCard = function (currNode) {
        var _this = this;
        var baseCardSize = this.kdChartObj.cardConfig.baseCardSize;
        this.nodes = this.kdChartObj.chartData.data.getNodes().reverse();
        var transition = this.group.transition().duration(500);
        var nodeGroup = this.gNode.selectAll("g")
            .data(this.nodes, function (d) { return d["id"]; });
        var nodeEnter = nodeGroup.enter().append("g")
            .attr("transform", getNodePaintLoc(currNode, baseCardSize, "init", this.previewScale));
        nodeEnter.append("rect")
            .attr("width", function (node) { return node.cardSize.width * _this.previewScale; })
            .attr("height", function (node) { return node.cardSize.height * _this.previewScale; })
            .attr("fill", "#fff")
            .attr("stroke", "#d9d9d9")
            .attr("stroke-opacity", 1)
            .attr("stroke-width", 0.5);
        // .attr("shape-rendering", "crispEdges")
        this.nodeUpdate = nodeGroup.merge(nodeEnter);
        this.nodeUpdate.transition(transition)
            .attr("transform", function (node) { return getNodePaintLoc(node, baseCardSize, "normal", _this.previewScale); })
            .attr("fill-opacity", 1)
            .attr("stroke-opacity", 1);
        nodeGroup.exit().transition(transition).remove()
            .attr("transform", getNodePaintLoc(currNode, baseCardSize, "normal", this.previewScale))
            .attr("stroke-opacity", 0)
            .attr("fill-opacity", 0);
    };
    PreViewObj.prototype.paintWin = function () {
        var _this = this;
        this.paintWinGroup = this.svg.append("g")
            .attr("transform", "translate(" +
                this.previewWinLoc.x + "," +
                this.previewWinLoc.y + ") scale(" +
                this.previewWinLoc.k + ")")
            .call(d3.drag()
                .on("drag", function (e) {
                    _this.dragWin(e.dx, e.dy);
                }));
        this.paintWinGroup.append("rect")
            .attr("width", this.preWinRectSize.width)
            .attr("height", this.preWinRectSize.height)
            .attr("fill-opacity", 0)
            .attr("stroke", "#5582F3")
            .attr("cursor", "pointer")
            .attr("stroke-width", 1)
            .attr("transform", "translate(" +
                this.previewWinRectLoc.x + "," +
                this.previewWinRectLoc.y + ")");
    };
    PreViewObj.prototype.dragWin = function (dx, dy) {
        // let rx = this.isInWinRectRangeX(dx)
        // let ry = this.isInWinRectRangeY(dy)
        this.moveWinGroup({
            rx: dx,
            ry: dy
        });
        this.kdChartObj.mainView.resetGroupLoc({
            rx: -dx / this.previewScale,
            ry: -dy / this.previewScale,
            k: this.kdChartObj.mainView.groupLoc.k
        });
    };
    PreViewObj.prototype.moveWinGroup = function (loc) {
        this.previewWinRectLoc.x += loc.rx;
        this.previewWinRectLoc.y += loc.ry;
        this.paintWinGroup.select("rect")
            .attr("transform", "translate(" + this.previewWinRectLoc.x + "," + this.previewWinRectLoc.y + ")");
    };
    PreViewObj.prototype.resetGroupLoc = function (loc) {
        this.moveWinGroup({
            rx: -loc.rx * this.previewScale,
            ry: -loc.ry * this.previewScale,
        });
        this.scaleWinGroup(loc.k);
    };
    PreViewObj.prototype.scaleWinGroup = function (k) {
        this.previewWinLoc.k = 1 / k;
        this.paintWinGroup.attr("transform", "translate(" +
            this.previewWinLoc.x + "," +
            this.previewWinLoc.y + ") scale(" +
            this.previewWinLoc.k + ")");
        this.paintWinGroup.select("rect")
            .attr("stroke-width", k);
    };
    PreViewObj.prototype.elbow = function (path, scale) {
        return getElbow(path, scale, this.kdChartObj.viewConfig.direction, this.kdChartObj.pathConfig.elbowRatio, this.kdChartObj.getPathScheme, this.kdChartObj.cardConfig.baseCardSize);
    };
    return PreViewObj;
}());

var KdChart = /** @class */ (function () {
    function KdChart(params) {
        //window.devicePixelRatio
        this.chartDom = params.dom;
        this.getCardModel = params.getCardModel;
        this.getCardSize = params.getCardSize;
        this.getPathScheme = params.getPathScheme;
        this.initParams(params);
        this.chartDom.style.position = "relative";
        this.chartDom.style.overflow = "hidden";
    }
    Object.defineProperty(KdChart.prototype, "editStatus", {
        get: function () {
            return this._editStatus || false;
        },
        set: function (val) {
            console.log("设置编辑态", val);
            this._editStatus = !!val;
            this.editCallBack();
        },
        enumerable: false,
        configurable: true
    });
    KdChart.prototype.initParams = function (params) {
        this.viewConfig = {
            direction: params.viewConfig ? (params.viewConfig.direction || 1) : 1
        };
        this.cardConfig = {
            baseCardSize: params.cardConfig ? (params.cardConfig.baseCardSize || DEFAULT_CARDSIZE) : DEFAULT_CARDSIZE,
            limitLevel: params.cardConfig ? (parseInt(params.cardConfig.limitLevel + "") || LimitLevel) : LimitLevel,
            lastLevel: params.cardConfig ? (params.cardConfig.lastLevel || false) : false
        };
        this.pathConfig = {
            elbowRatio: params.pathConfig ? (params.pathConfig.elbowRatio || ElbowRatio) : ElbowRatio,
        };
        var sww = this.chartDom.offsetWidth;
        var swh = this.chartDom.offsetHeight;
        // if (params?.baseConfig?.sww) sww = Math.min(params.baseConfig.sww, this.chartDom.offsetWidth)
        // if (params?.baseConfig?.sww) swh = Math.min(params.baseConfig.swh, this.chartDom.offsetHeight)
        this.svgWrapperSize = {
            width: sww,
            height: swh
        };
        //实例化原始数据
        this.treeData = new TreeDataObj(this, params.treeData);
        //实例化chart数据
        this.chartData = new ChartDataObj(this, params.computedCoordinate, params.formatData);
    };
    KdChart.prototype.initMainView = function (mvParams) {
        //实例化主图
        this.mainView = new MainViewobj(this, mvParams);
    };
    KdChart.prototype.initPreView = function (preParams) {
        //实例化预览图
        this.preView = new PreViewObj(this, preParams);
    };
    KdChart.prototype.getPPTParams = function () {
        return {
            nodes: this.chartData.data.getNodes(),
            links: this.chartData.data.getLinks(),
            rootNode: this.chartData.data,
            baseCardSize: this.cardConfig.baseCardSize,
            cardModel: this.mainView.cardModel,
            elbowRatio: this.pathConfig.elbowRatio,
            direction: this.viewConfig.direction
        };
    };
    KdChart.prototype.getPngPdfParams = function () {
        return {
            nodes: this.chartData.data.getNodes(),
            links: this.chartData.data.getLinks(),
            rootNode: this.chartData.data,
            baseCardSize: this.cardConfig.baseCardSize,
            cardModel: this.mainView.cardModel,
            elbowRatio: this.pathConfig.elbowRatio,
            minLoc: this.mainView.minLoc,
            relativeMaxLoc: this.mainView.relativeMaxLoc
        };
    };
    //class:ChartDataObj 使用
    KdChart.prototype.kdGetCardModel = function (node, chartData) {
        return typeof this.getCardModel === "function" ?
            (this.getCardModel(node, chartData) || "normal") : "normal";
    };
    //class:ChartDataObj 使用
    KdChart.prototype.keGetCardSize = function (node, chartData) {
        return typeof this.getCardSize === "function" ?
            (this.getCardSize(node, chartData) || this.cardConfig.baseCardSize) : this.cardConfig.baseCardSize;
    };
    //编辑类型
    //排序
    //挂载方式
    //标记框
    KdChart.prototype.upEditStatus = function (flag) {
        if (flag === void 0) { flag = false; }
        this.editStatus = flag;
    };
    KdChart.prototype.editCallBack = function () {
        if (this._editStatus) {
            d3.selectAll(".markIcon").style("display", "");
            d3.selectAll(".card-wrapper").attr("cursor", "move");
        }
        else {
            d3.selectAll(".markIcon").style("display", "none");
            d3.selectAll(".card-wrapper").attr("cursor", "");
        }
    };
    KdChart.prototype.resetWrapperSize = function (w, h) {
        this.svgWrapperSize = {
            width: w,
            height: h
        };
        this.mainView.resetWrapperSize();
        this.preView.resetWrapperSize();
    };
    KdChart.prototype.resetData = function (newData) {
        this.treeData.resetData(newData);
        this.chartData.resetData();
        this.mainView.resetData();
        this.preView.resetData();
    };
    KdChart.prototype.addCard = function () {
        var _this = this;
        if (this.mainView.chartCard.selectedCard.length === 0)
            return;
        var currNode = this.mainView.chartCard.selectedCard[0];
        console.log("currNode", currNode);
        this.treeData.addOneCrad(currNode.id);
        this.chartData.resetData();
        this.chartData.resetChartData();
        this.chartData.searchNodeByID(currNode.id, function (currChartData) {
            _this.mainView.resetPaint(currChartData, true);
        });
        // this.mainView.clearSelectCard()
    };
    KdChart.prototype.delCard = function () {
        var _this = this;
        var delIDs = [];
        this.mainView.chartCard.selectedCard.map(function (item) {
            if (item.id !== _this.chartData.data.id) {
                delIDs.push(item.id);
            }
        });
        this.treeData.delCards(delIDs);
        this.chartData.resetData();
        this.chartData.resetChartData();
        this.mainView.resetPaint(this.chartData.data, true);
        this.mainView.clearSelectCard();
    };
    //更改子节点挂在方式
    KdChart.prototype.changeChildLoadType = function () {
    };
    KdChart.prototype.showCardMenu = function (currNode) {
        this.mainView.cardMenu.showCardMenu(currNode);
    };
    KdChart.prototype.hideCardMenu = function () {
        this.mainView.cardMenu.delCardMenu();
    };
    KdChart.prototype.menuAdd = function () {
        var _this = this;
        var currNode = this.mainView.cardMenu.currOpNode;
        this.treeData.addOneCrad(currNode.id);
        this.chartData.resetData();
        this.chartData.resetChartData();
        this.chartData.searchNodeByID(currNode.id, function (currChartData) {
            _this.mainView.resetPaint(currChartData, true);
        });
        this.mainView.cardMenu.resetCardMenu(currNode);
    };
    KdChart.prototype.menuDel = function () {
        var currNode = this.mainView.cardMenu.currOpNode;
        var delIDs = [currNode.id];
        this.treeData.delCards(delIDs);
        this.chartData.resetData();
        this.chartData.resetChartData();
        this.mainView.resetPaint(this.chartData.data, true);
        this.mainView.clearSelectCard();
        this.mainView.cardMenu.delCardMenu();
    };
    return KdChart;
}());

export { KdChart as default };
